if (!Librarian.Utils) {
    Librarian.Utils = {
        toBoolean: function (value) {
            if (value == null)
                return false;
            return value.toLowerCase() == "true";
        },

        getHash: function () {
            var hash = window.location.hash;
            hash = hash.indexOf("#/") > -1 ? hash.substring(2) : hash.substring(1);

            return hash;
        },

        canDownload: function (data) {
            if (Librarian.Utils.isSlideShow(data))
                return false;

            // Don't let DeepLink users download GFs and VPs
            if (Librarian.isGuest && ((data.groupid > 0) || (data.presid > 0) || data.groupinfo))
                return false;

            var ext = Librarian.Utils.getExtensionFromData(data);
            return !Librarian.download.excludeTypes.contains(ext);
        },
        canStream: function (data) {
            var ext = Librarian.Utils.getExtensionFromData(data, true);
            return (Librarian.preview.allowVideoStreaming && Librarian.extensions.isStreamableVideo(ext)) ||
                (Librarian.preview.allowAudioStreaming && Librarian.extensions.isStreamableAudio(ext));
        },
        createLinkFromString: function (string) {
            var exp = /\(?\b(http|https):\/\/[-A-Za-z0-9+&@#\/%?=~_()|!:,.;]*[-A-Za-z0-9+&@#\/%=~_()|]/ig;

            // $& uses the whole match from the regular expression. $1 would just return http or https
            return string.replace(exp, '<a href="$&" target="_blank' + (new Date().getTime()) + '">$&</a>');
        },
        getArrayFromCSV: function (text, skip, delim) {
            if ((typeof delim == "undefined") || (delim == null))
                delim = "\t";

            var values = Librarian.Utils.getArrayFromText(text, skip);

            // Split each value by tabs
            for (var i = values.length; i--;) {
                // Remove empty strings
                if (values[i].trim().length == 0) {
                    values.remove(i);
                    continue;
                }

                values[i] = values[i].split(new RegExp("[" + delim + "]", "g"));
            }

            return values;
        },
        getArrayFromFile: function (text, skip) {
            return Librarian.Utils.getArrayFromText(text, skip);
        },
        getObjectromFile: function (text) {
            var data = [];

            var selection = Librarian.Utils.getArrayFromFile(text, 1);
            var headers = (text.match(/[^\r\n]+/)[0].split(/[\t]/g) || []).map(function (datum) {
                return datum.trim();
            });

            for (var i = 0, len = selection.length; i < len; i++) {
                // Remove empty strings
                if (selection[i].trim().length == 0) {
                    selection.remove(i);
                    continue;
                }

                var columns = selection[i].split(/[\t]/g);

                var info = {};
                Array.each(columns, function (col, index) {
                    var propName = headers[index];

                    info[propName] = col.trim();
                });

                data.push(info);
            }

            return data;
        },
        getArrayFromText: function (text, skip) {
            // Carriage return and line feed
            var cr = /\\r/g,
                lf = /\\n/g;

            var lines = (text || '').split(/\r?\n/);

            // Removed escaped carriage return and new line
            for (var len = lines.length; len--;) {
                lines[len] = lines[len].replace(cr, "\r");
                lines[len] = lines[len].replace(lf, "\n");
            }

            if ((typeof skip == "number") && (skip > 0)) {
                return lines.slice(skip);
            }

            return lines;
        },
        error: function(message, closeAfter) {
            if (closeAfter == null)
                closeAfter = 5000;

            return Librarian.Utils.showNotification(message, "error", closeAfter);
        },
        notification: function(message, closeAfter) {
            if (closeAfter == null)
                closeAfter = 3000;

            return Librarian.Utils.showNotification(message, "notification", closeAfter);
        },
        showNotification: function(message, type, closeAfter) {
            var notification = new Librarian.Notification({
                message: message,
                type: type,
                closeAfter: closeAfter
            });

            return notification;
        },
        closeNotifications: function(type) {
            Librarian.Notification.closeAll(type);
        },
        showCartNotification: function (data, type, success) {
            if (!(Librarian.features.fastlane.load && Librarian.FastLane.isEnabled)) {
                if (Librarian.cart.showDetailedMessages) {
                    var itemType = Librarian.Utils.getItemTypeString(data);

                    if (type == Librarian.cartNotificationTypes.removed) {
                        if (success) {
                            Librarian.Utils.notification(Librarian.Lang.getArgString("cart_removed_type", [itemType]), Librarian.cart.notificationTime);
                        } else {
                            Librarian.Utils.notification(Librarian.Lang.getArgString("cart_remove_failed", [itemType]), Librarian.cart.notificationTime);
                        }
                    } else if (success) {
                        Librarian.Utils.notification(Librarian.Lang.getArgString("cart_added", [itemType]), Librarian.cart.notificationTime);
                    }
                }
                else {
                    Librarian.Utils.notification(Librarian.Lang.getString("cart_updated"));
                }
            }
        },
        openSendWindow: function (data, options) {
            if (!Librarian.event.canShare) {
                return null;
            }

            if (!options)
                options = {};

            var win = new Librarian.EventSendWindow(options, data);
            win.show();

            return win;
        },
        openCampaignWindow: function (options) {
            if (!options.campaignInfo)
                throw "No campaign info";

            if (options.campaignInfo.isdraft) {
                var confirm = new Librarian.ConfirmWindow({
                    question: Librarian.Lang.getString("eventgroup_send_draft?")
                });

                confirm.onFirstButtonClicked = function () {
                    new Librarian.CampaignWindow(options);
                }.bind(this);
            }
            else
                new Librarian.CampaignWindow(options);
        },
        openURLFile: function (data) {
            Librarian.Utils.getSlideText(data, function (json) {
                if (json) {
                    window.open(json.Text.trim(), "_blank" + new Date().getTime());

                    var logType = Librarian.activityLogType.preview;

                    var fileId = data.fileid,
                        fileName = encodeURIComponent(data.filename || data.name),
                        url = Librarian.path.getLogUrl("logact") + "&cntid=" + fileId + "&cnttype=1&name=" + fileName + "&logtype=" + logType;

                    new Librarian.Request({
                        url: url,
                        async: true
                    }).send();
                }
            });
        },
        openUploader: function (callback) {
            function doOpen() {
                if (Librarian.features.clouduploader.load) {
                    var cloudUploadWindow = new Librarian.CloudUploadWindow();

                    cloudUploadWindow.show();
                }
                else if (Librarian.features.html5uploadwindow.load && Librarian.Utils.hasHtml5UploadSupport()) {
                    var html5UploadWindow = new Librarian.Html5UploadWindow({
                        complete: function (files) {
                            if (typeof callback == "function")
                                callback(files);
                        }
                    });

                    html5UploadWindow.show();
                }
            }

            if (Librarian.upload.disclaimer != null) {
                var confirm = new Librarian.ConfirmWindow({
                    id: "UploadAgreeWindow",
                    height: Librarian.upload.disclaimerHeight,
                    width: 500,
                    title: Librarian.Lang.getString("disclaimer"),
                    firstButtonText: Librarian.Lang.getString("agree"),
                    secondButtonText: Librarian.Lang.getString("cancel"),
                    question: Librarian.upload.disclaimer,
                    resize: false
                });
                confirm.onFirstButtonClicked = doOpen;
            }
            else
                doOpen();
        },
        notifyUploadComplete: function (successCount, failureCount) {
            var method = "notification";
            var message = "";

            if (successCount > 0)
                message += "<div>" + Librarian.Lang.getPluralArgString("upload_success_count", successCount, [successCount]) + "</div>";

            if (failureCount > 0) {
                method = "error";
                message += "<div>" + Librarian.Lang.getPluralArgString("upload_failure_count", failureCount, [failureCount]) + "</div>";
            }

            if (message)
                Librarian.Utils[method](message, 5000);

            window.fireEvent("uploadFile");
        },
        getSlideShowURL: function (data, type) {
            var url = Librarian.path.getAppPath("slideshow") + '/' + type + ".htm?libName=" + Librarian.path.getUrlLibraryName(),
                loginKey = window.location.search.substring(1).parseQueryString().lkey,
                hashData = this.getHash().parseQueryString(),
                frameName = '_' + type;
            if (Librarian.sessionName)
                url += "&sname=" + Librarian.sessionName;
            if ((typeof loginKey == "string") && (loginKey.length > 0))
                url += "&lkey=" + loginKey;

            // Include any data we have
            if (data) {
                if (data.presid > 0) {
                    url += "&presId=" + data.presid;
                    frameName += data.presid;
                }

                if (data.catid > 0)
                    url += "&catId=" + data.catid;
                else if ((typeof hashData.catid == "string") && (hashData.catid.length > 0))
                    url += "&catId=" + hashData.catid;
            }
            else if ((typeof hashData.catid == "string") && (hashData.catid.length > 0))
                url += "&catId=" + hashData.catid;

            return { url: url, frameName: frameName };
        },
        openSlideShow: function (data, type) {
            var slideShowURL = Librarian.Utils.getSlideShowURL(data, type),
                winSize = window.getSize();

            window.open(slideShowURL.url, slideShowURL.frameName + (new Date()).getTime(), "directories=no,channelmode=yes,resizable=yes,location=yes,height=" + winSize.y + ",width=" + winSize.x);
        },
        getArticleDesignerURL: function () {
            return Librarian.path.getAppPath("articles") + "/designer.htm?libName=" + Librarian.path.getUrlLibraryName();
        },
        openArticleDesigner: function () {
            var adURL = Librarian.Utils.getArticleDesignerURL();
            window.open(adURL);
        },
        openWorkflowToDo: function () {
            Librarian.todoWindow = new Librarian.WorkflowTodoWindow();
            Librarian.todoWindow.onDoubleClick = Library.openWorkflowWizardWindow;
            if (typeof Library.workflowInstanceClick == "function")
                Librarian.todoWindow.onClick = Library.workflowInstanceClick;
            Librarian.todoWindow.show();
        },
        getSlideText: function (data, onSuccess, type, onFailure) {
            var slidenum = data.slidenumber || 1;

            // Don't log 404 errors
            var params = "&ignoreerror=true";

            if (data.slideid > 0)
                params += "&sid=" + data.slideid;
            else if (data.fileid > 0)
                params += "&fid=" + data.fileid + "&snum=" + slidenum;
            else if (data.presid > 0)
                params += "&pid=" + data.presid + "&snum=" + (data.itemnumber || slidenum);
            else if (data.groupid > 0)
                params += "&gid=" + data.groupid + "&snum=" + slidenum;
            else if (data.filename && data.filename.length > 0)
                params += "&fname=" + encodeURIComponent(data.filename) + "&snum=" + slidenum;
            else
                return;

            if ((typeof type != "undefined") && (type != null))
                params += "&subtype=" + type;

            if (Librarian.catType.isUserCategory(data.cattype))
                params += "&useweb=false";

            new Librarian.Request.JSON({
                url: Librarian.path.getMethodUrl("getslidetext") + params + "&out=ujson",
                onSuccess: onSuccess || $empty,
                onFailure: onFailure || $empty
            }).send();
        },
        getSlideTextArray: function (data, onSuccess, type, onFailure) {
            Librarian.Utils.getSlideText(data, function (result) {
                if (!result || !result.Text) {
                    if (typeof onFailure == "function")
                        onFailure();
                    return;
                }

                var array = Librarian.Utils.getArrayFromFile(result.Text);

                if (typeof onSuccess == "function")
                    onSuccess(array);
            }, type, onFailure);
        },
        getFileID: function (fileName, onSuccess, onFailure, ignoreExtension) {
            var url = Librarian.path.getMethodUrl("getfid") + "&out=ljson&fname=" + encodeURIComponent(fileName);
            if (ignoreExtension === true) {
                url += "&ignoreextension=" + ignoreExtension + "&cattype=2";
            }

            new Librarian.Request.JSON({
                url: url,
                onSuccess: onSuccess,
                onFailure: function(error) {
                    Librarian.Utils.onFailure(error);
                    if (typeof onFailure == "function")
                        onFailure();
                }
            }).send();
        },
        getFileInfo: function(fileId, onSuccess, onFailure) {
            var url = Librarian.path.getMethodUrl("getfi") + "&out=ljson&fid=" + encodeURIComponent(fileId);

            new Librarian.Request.JSON({
                url: url,
                onSuccess: onSuccess,
                onFailure: function(error) {
                    Librarian.Utils.onFailure(error);
                    if (typeof onFailure == "function")
                        onFailure();
                }
            }).send();
        },
        deleteUserFile: function(fileId, onSuccess, onFailure) {
            var url = Librarian.path.getUpdateUrl("deleteuserfile") + "&out=ljson&fid=" + encodeURIComponent(fileId);

            new Librarian.Request.JSON({
                url: url,
                onSuccess: onSuccess,
                onFailure: function(error) {
                    Librarian.Utils.onFailure(error);
                    if (typeof onFailure == "function")
                        onFailure();
                }
            }).send();
        },

        getFileHash: function (fileid, name, onSuccess, onFailure) {
            if (typeof onSuccess != "function")
                return null;

            var params;
            if (fileid > 0)
                params = "&fid=" + fileid;
            else
                params = "&fname=" + encodeURIComponent(name);

            return new Librarian.Request({
                url: Librarian.path.getMethodUrl("getfh") + "&out=text" + params,
                onSuccess: onSuccess,
                async: false,
                onFailure: function(error) {
                    Librarian.Utils.onFailure(error);
                    if (typeof onFailure == "function")
                        onFailure();
                }
            }).send();
        },
        getAttributeFromArray: function (attribList, attribName) {
            if (!attribList || !attribName)
                return null;

            for (var i = 0; i < attribList.length; i++) {
                var attrib = attribList[i];

                if ((attrib.name == attribName) || (attrib.Name == attribName))
                    return attrib.value || attrib.Value;
            }

            return null;
        },
        getAttributesFromArray: function (attribList) {
            var attributes = {};
            if (attribList) {
                for (var i = 0; i < attribList.length; i++) {
                    var attrib = attribList[i];

                    var name = attrib.name || attrib.Name;
                    var value = attrib.value || attrib.Value;

                    attributes[name] = value;
                }
            }

            return attributes;
        },
        getAttributeDropdownValues: function (attribId, attribName, onSuccess, onFailure, includeInfo) {
            if ((!attribId || (attribId < 0)) && (!attribName || (attribName.length == 0)))
                return null;

            var params;
            if (attribId && (attribId >= 0))
                params = "&atid=" + attribId;
            else
                params = "&atname=" + encodeURIComponent(attribName);

            var request = new Librarian.Request.JSON({
                url: Librarian.path.getMethodUrl("getadv") + params + "&out=ujson",
                onFailure: function(error) {
                    Librarian.Utils.onFailure(error);
                    if (typeof onFailure == "function")
                        onFailure();
                },
                onSuccess: function (json) {
                    if (!json)
                        return;

                    if (includeInfo === true) {
                        onSuccess(json, attribName);
                        return;
                    }

                    var values = json.map(function (item) {
                        return item.Value;
                    });
                    onSuccess(values, attribName, json);
                }
            });
            request.send();
            return request;
        },
        getFileTypes: function (onSuccess, onFailure) {
            var request = new Librarian.Request.JSON({
                url: Librarian.path.getMethodUrl("getftypes") + "&out=ujson",
                onFailure: function(error) {
                    Librarian.Utils.onFailure(error);
                    if (typeof onFailure == "function")
                        onFailure();
                },
                onSuccess: onSuccess
            });
            request.send();
        },
        getThumbnailUrl: function (size, data, track, expand, parentData) {
            var slideNum, itemNum, noSource = false;
            if (data) {
                // Get the source file's extension (if there is one)
                var sourceext = Librarian.Utils.getExtensionFromData(data, true),
                    // Whether or not this is a file pretending to be a slide
                    fileAsSlide = Librarian.extensions.hasFakeSlides(sourceext);

                slideNum = data.slidenumber;

                // If there is no slide number, there is an invalid slide number,
                // or this is a file pretending to be a slide, use the first "slide" in the file
                if (!slideNum || (slideNum < 0) || fileAsSlide)
                    slideNum = 1;

                itemNum = (data.itemnumber || slideNum);

                // If this is a presentation with a -1 slide id and an invalid file type,
                // the source isn't available and we should show the "No Image Available" image
                if (Librarian.Utils.isSourceNotAvailable(data))
                    noSource = true;
            }
            else
                noSource = true;


            var isCategory = false;
            var url = Librarian.path.getThumbnailUrl() + "&tname=" + size;

            if (!noSource) {
                if (data.editFileName)
                    url = Librarian.path.getDownloadUrl("spv") + "&tname=" + size + "&fname=" + encodeURIComponent(data.editFileName);
                else if (data.thumbnailid)
                    url += "&tnid=" + data.thumbnailid;
                else if (data.presid)
                    url += "&pid=" + data.presid + "&comp=1&snum=" + itemNum + "&expand=" + ((Librarian.tileList.expandGroupItemsToSlides || (expand === true)) ? '1' : '0');
                else if (data.slideid > 0)
                    url += "&sid=" + data.slideid;
                else if (data.groupid) {
                    // If this has an event count, its an event group not a Global Favorite
                    if (typeof data.eventcount == "number")
                        url += "&egid=" + data.groupid + "&snum=" + itemNum;
                    else
                        url += "&gid=" + data.groupid + "&snum=" + itemNum + "&expand=" + ((expand === true) ? '1' : '0');
                }
                else if (data.fileid)
                    url += "&fid=" + data.fileid + "&snum=" + slideNum;
                else if (data.eventid)
                    url += "&eid=" + data.eventid;
                else if (data.catid) {
                    url = Librarian.path.getThumbnailUrl("catthumb") + "&cid=" + data.catid
                    isCategory = true;
                    //url = Librarian.path.getLibraryPath() + "img/folder.jpg";
                    //track = false;
                }
                else if (data.contentid && data.contenttype)
                    url += "&cntid=" + data.contentid + "&cnttype=" + data.contenttype + "&snum=" + itemNum;
                else if (data.supportfileid)
                    url += "&cntid=" + data.supportfileid + "&cnttype=" + Librarian.contentType.supportFile + "&snum=" + itemNum;
                else {
                    url = null;
                    track = false;
                }
            }
            else {
                url = null;
                track = false;
            }

            if (url) {
                if (track === true)
                    url += "&track=1&" + String.uniqueID();
                else if (data && !data.thumbnailid)
                    url += "&cacheid=" + Librarian.cacheId;

                if (data.instanceid > 0 || (parentData && parentData.instanceid > 0))
                    url += "&useweb=false";

                if (!isCategory) {
                    // Pass the icon path as an alternative
                    var ext = Librarian.Utils.getExtensionFromData(data);
                    var altUrl = Librarian.Utils.getFileTypeIcon(ext, 32);

                    url += "&alt=" + encodeURIComponent(altUrl);
                }
                else {
                    url += "&alt=" + encodeURIComponent(Librarian.Utils.getFileTypeIcon('', 64, true));
                }
            }
            else {
                url = Librarian.path.getFullPath(Librarian.path.root + "/img/NotAvailable.jpg");
            }

            return url;
        },

        getFileTypeIcon: function (ext, size, category) {
            ext = (ext || '').trim().toLowerCase();
            category = !!category;
            size = size || '';

            var version = Librarian.extensions.fileTypeIconsVersion;

            switch (version) {
                case 1:
                    return this.getFileTypeIcon_v1(ext, size, category);
                case 2:
                    return this.getFileTypeIcon_v2(ext, size, category);
                case 3:
                    return this.getFileTypeIcon_v3(ext, size, category);
                default:
                    return "";
            }
        },

        getFileTypeIcon_v1: function(ext, size, category) {
            var fileName;

            if (category) {
                fileName = 'CategoryFolder';
                if (ext === "favorite") {
                    fileName = "FavoritesFolder";
                }

                if (size && (typeof size == "number")) {
                    fileName += '_' + size;
                }
            }
            else {
                fileName = ext;

                if (size && (typeof size == "number")) {
                    fileName = size + '_' + fileName;
                }
            }

            fileName += ".gif";

            return Librarian.path.getFileTypeIconsPath("v1") + fileName;
        },

        getFileTypeIcon_v2: function(ext, size, category) {
            var fileName;

            if (category) {
                if (ext === "favorite") {
                    fileName = "FAV_Folder";
                }
                else {
                    fileName = "YEL_Folder";
                }
            }
            else {
                fileName = Librarian.Utils.getFileTypeIconName(ext);
            }

            if (typeof size != "number")
                size = 16;

            fileName += "_Icon_" + size + ".png";

            return Librarian.path.getFileTypeIconsPath("v2") + fileName;
        },

        getFileTypeIcon_v3: function(ext, size, category) {
            // Use v2 category icons
            if (category)
                return Librarian.Utils.getFileTypeIcon_v2(ext, size, category);

            var fileName = Librarian.Utils.getFileTypeIconName(ext);

            // Use 2x icons
            if (size == 32)
                fileName += "_64";
            else
                fileName += "_32";

            fileName += ".png";

            return Librarian.path.getFileTypeIconsPath("v3") + fileName;
        },

        getFileTypeIconName: function(ext) {
            var type = Librarian.extensions.getFileType(ext);

            var icons = {
                powerpoint: "PowerPoint",
                pdf: "PDF",
                text: "Text",
                word: "Word",
                excel: "Excel",
                vector: "Vector",
                image: "Image",
                video: "Video",
                audio: "Audio",
                archive: "Archive",
                favorite: "Favorite",
                link: "Link",
                wizard: "Wizard",
                campaign: "Campaign",
                page: "Page",
                magic: "Magic"
            };

            return icons[type] || "Default";
        },

        getNaturalImageSize: function (imageEl) {
            if (!imageEl)
                return null;

            var width = imageEl.naturalWidth,
                height = imageEl.naturalHeight;

            // If we can't use natural width or height, make a fake image that isn't hidden and pull the size from that
            if ((typeof width != "number") || isNaN(width) || (typeof height != "number") || isNaN(height)) {
                var tempImageEl = new Image();
                tempImageEl.src = imageEl.src;

                width = tempImageEl.width;
                height = tempImageEl.height;
            }

            return { x: width, y: height };
        },
        getFileDownloadUrl: function (data, mode, newName, extension) {
            if ((typeof mode == "undefined") || (mode == null))
                mode = "dnld";
            var fileid = data.fileid || data,
                url = '';

            if (fileid) {
                url = Librarian.path.getDownloadUrl() + "mode=" + mode + "&fid=" + fileid;

                if (newName)
                    url += "&name=" + encodeURIComponent(newName);
                if (extension)
                    url += "&ext=" + encodeURIComponent(extension);
            }

            if (data.requestid)
                url += "&rid=" + data.requestid;

            return url;
        },
        download: function(url, filename) {
            if (typeof filename != "string")
                filename = "";

            var link = new Element("a", {
                href: url,
                download: filename
            });

            link.click();
        }, 
        getPath: function (data, onComplete, name) {
            if (!data)
                return;
            if (typeof onComplete != "function")
                return;
            if ((typeof name == "undefined") || (name == null))
                name = false;

            var method = "getcpath",
                id = "&cid=" + data.catid,
                catType = Librarian.catType.file;

            if (data.type != null)
                catType = data.type;
            else if (data.cattype != null)
                catType = data.cattype;

            if (data.groupid > 0) {
                method = "getpath";
                var shortName = "gid";
                if (data.type == Librarian.catType.event || data.cattype == Librarian.catType.event)
                    shortName = "egid";

                id += '&' + shortName + '=' + data.groupid;
            }
            else if (data.eventid > 0 && data.parentid) {
                method = "getpath";
                var shortName = "egid";

                id += '&' + shortName + '=' + data.parentid;
            }
            else if (data.presid > 0) {
                method = "getpath";
                id += "&pid=" + data.presid;
            }
            else if (data.fileid > 0) {
                method = "getpath";
                id += "&fid=" + data.fileid;
            }
            else if (typeof data.path == "string")
                id += "&cname=" + encodeURIComponent(data.path);

            var url = Librarian.path.getMethodUrl(method) + "&catType=" + catType + id + "&out=text";
            if (name)
                url += "&name=true";

            var request = new Librarian.Request({
                url: url,
                onSuccess: onComplete,
                onFailure: function () {
                    onComplete(null);
                }
            });
            request.send();
        },
        getCatFromPath: function (path, onComplete, onFailure) {
            if (!path)
                return;
            if (typeof onComplete != "function")
                return;

            var url = Librarian.path.getMethodUrl("getcatfp") + "&cpath=" + path + "&out=cjson",
                request = new Request.JSON({
                    url: url,
                    onSuccess: onComplete,
                    onFailure: function(error) {
                        Librarian.Utils.onFailure(error);
                        if (typeof onFailure == "function")
                            onFailure();
                    }
                });
            request.send();
        },
        getSearchContext: function (term, sid, onComplete) {
            var request = new Librarian.Request({
                url: Librarian.path.getMethodUrl("getslidetext") + "&out=stext&sid=" + sid +
                    "&sterms=" + encodeURIComponent(term) +
                    "&max=512&mclass=searchContext&mtag=span",
                onSuccess: onComplete
            });
            request.send();
        },
        getItemType: function (data) {
            if (data) {
                var ext = Librarian.Utils.getExtensionFromData(data, true);
                if ((data.slideid > 0) || (data.contenttype == Librarian.contentType.slide)) {
                    if (ext.startsWith("ppt") || ext.startsWith("pps") || ext.startsWith("pot"))
                        return "slide";
                    else
                        return "page";
                }
                else if (data.eventid > 0)
                    return "event";
                else if (typeof data.eventcount == "number")
                    return "eventgroup";
                else if ((data.groupid > 0) || (data.presid > 0))
                    return "group";
            }

            return "item";
        },
        getItemTypeString: function (data) {
            var type = Librarian.Utils.getItemType(data);

            return Librarian.Lang.getString(type);
        },
        isSourceNotAvailable: function (data) {
            return data && (data.presid > 0) && (data.slideid > 0) && (data.slidenumber <= 0);
        },
        getNameWithoutExtension: function (filename) {
            if (!filename)
                return '';

            var extIndex = filename.lastIndexOf('.');
            if (extIndex < 0)
                return filename;

            return filename.substring(0, extIndex);
        },
        getExtension: function (filename) {
            if (!filename)
                return '';

            filename = Librarian.Utils.undecorateFileName(filename);
            // Get the index of the last . so we can get the extension
            var extIndex = filename.lastIndexOf('.');
            if (extIndex < 0)
                return '';

            return filename.substring(extIndex + 1).toLowerCase();;
        },
        getExtensionFromData: function (data, includeSource) {
            if (!data)
                return '';

            data = Object.toLowerKeys(data);

            if ((typeof includeSource == "undefined") || (includeSource == null))
                includeSource = false;

            var fileData = (data.fileinfo || data.groupinfo || data),
                ext = null;
            // If we're supposed to include the source, get that first
            // The source should only ever be a valid file type, so ignore it if it's "vpres" for some reason
            if (includeSource && (fileData.sourceext != "vpres"))
                ext = fileData.sourceext;

            // Get the extension from all the possibilities
            ext = ext || fileData.filetypeextension || fileData.ext || '';
            // If the extension starts with a ., drop it
            if (ext.startsWith('.'))
                ext = ext.substring(1);

            // Trim off any whitespace
            ext = ext.trim();

            // If we don't have an extension, try to get it from the file name
            if (ext.length == 0)
                ext = (Librarian.Utils.getExtension(fileData.filename || fileData.contentname || fileData.name) || '').trim();
            // If we still don't have an extension, check for special ones
            if (ext.length == 0) {
                if (fileData.groupid > 0) {
                    ext = "favg";

                    // If this has an event count, its an event group not a Global Favorite
                    if (fileData.eventcount > 0)
                        ext = "evtg";
                }
                else if (fileData.presid > 0)
                    ext = "vpres";
            }

            // Trim whitespace again and return the lowercase
            return ext.trim().toLowerCase();
        },
        getFileNameFromPath: function (fullPath) {
            var fileName = '';
            if (fullPath)
                fileName = fullPath.replace(/^.*[\\\/]/, '');

            return fileName;
        },
        getRequestInfo: function (requestId, onSuccess, onFailure) {
            var request = new Librarian.Request.JSON({
                url: Librarian.path.getMethodUrl("getr") + "&rid=" + requestId + "&out=ujson",
                onSuccess: onSuccess,
                onFailure: function(error) {
                    Librarian.Utils.onFailure(error);
                    if (typeof onFailure == "function")
                        onFailure();
                }
            });
            request.send();
        },
        getLink: function (data, isDownload) {
            if (!data)
                return null;

            if (Librarian.linkWindow != null) {
                Librarian.linkWindow.close();
                Librarian.linkWindow = null;
            }

            // Make sure we don't have some inner object
            data = data.fileinfo || data.groupinfo || data;

            var url = null;
            // If this is absolutely a file and we're told to use the download link
            if (isDownload &&
                (typeof data.fileid == "number") && (data.fileid > 0) &&
                ((typeof data.groupid != "number") || (data.groupid <= 0)) &&
                ((typeof data.presid != "number") || (data.presid <= 0)) &&
                ((typeof data.slideid != "number") || (data.slideid <= 0)) &&
                ((typeof data.slidenumber != "number") || (data.slidenumber <= 0))) {
                Librarian.Utils.getFileHash(data.fileid, null, function (hash) {
                    url = Librarian.path.getRootURL();
                    // If we have a root, build the whole rest of the URL before the library
                    if (Librarian.path.root.length > 0)
                        url += Librarian.path.root + '/' + Librarian.path.libraries;
                    url += '/' + Librarian.path.getUrlLibraryName() + '/' + Librarian.path.getDownloadUrl(Librarian.pageHeaders.downloadLinkMode) + "&fh=" + hash;
                });
            }
            else {
                url = window.location.origin + window.location.pathname;

                if (data.fileid) {
                    url += "#fileid=" + data.fileid;
                }
                else if (data.groupid && data.contenttype == Librarian.contentType.eventGroup) {
                    url += "#groupid=" + data.groupid + "&type=5";
                    if (data.catid) {
                        url += "&catid=" + data.catid;
                    }
                }
                else if (data.groupid) {
                    url += "#groupid=" + data.groupid + "&type=1";
                }
                else {
                    url += window.location.hash;
                };

                if (!url.includes("catid") && data.catid && data.contenttype == Librarian.contentType.category) {
                    url += "#catid=" + data.catid + "&type=" + data.type;
                }

                if (Librarian.pageHeaders.libraryLinkPreview && data.contenttype !== Librarian.contentType.category) {
                    url += "&preview=true";
                };
            }

            Librarian.linkWindow = new Librarian.InfoWindow({
                title: Librarian.Lang.getArgString("info_title", [data.groupname || data.name || data.filename]),
                content: url
            });

            Librarian.linkWindow.show();
        },
        getTopRated: function (count, catType, onSuccess, onFailure, outputType, useGetSendData, customSendData) {
            var searchType = Librarian.Search.outputTypes.FILES;
            if (catType == Librarian.catType.globalFavorite)
                searchType = Librarian.Search.outputTypes.GROUPS;
            return Librarian.Utils.getFilesByMethod(count, onSuccess, onFailure, "gettoprated", searchType, outputType, { type: catType }, useGetSendData, customSendData);
        },
        getPopular: function (count, contentType, onSuccess, onFailure, outputType, useGetSendData, customSendData) {
            var searchType = Librarian.Search.outputTypes.FILES;
            if (contentType == Librarian.contentType.globalFavorite)
                searchType = Librarian.Search.outputTypes.GROUPS;
            else if (contentType == Librarian.contentType.slide)
                searchType = Librarian.Search.outputTypes.SLIDES;
            return Librarian.Utils.getFilesByMethod(count, onSuccess, onFailure, "getpopc", searchType, outputType, { type: contentType }, useGetSendData, customSendData);
        },
        getNewestFiles: function (count, onSuccess, onFailure, outputType, excludeExtensions, useGetSendData, customSendData) {
            return Librarian.Utils.getFilesByMethod(count, onSuccess, onFailure, "getnewf", Librarian.Search.outputTypes.FILES, outputType, excludeExtensions ? { exclude: excludeExtensions.join(',') } : null, useGetSendData, customSendData);
        },
        getNewestGroups: function (count, onSuccess, onFailure, outputType, notUsed, useGetSendData, customSendData) {
            return Librarian.Utils.getFilesByMethod(count, onSuccess, onFailure, "getnewcg", Librarian.Search.outputTypes.GROUPS, outputType, null, useGetSendData, customSendData);
        },
        getNewestEventGroups: function (data, extraInfo, onSuccess, onFailure, outputType) {
            return Librarian.Utils.getEventGroupsByMethod(onSuccess, onFailure, "getrecgs", outputType, data, extraInfo);
        },
        getPopularEventGroups: function (data, extraInfo, onSuccess, onFailure, outputType) {
            return Librarian.Utils.getEventGroupsByMethod(onSuccess, onFailure, "getpopgs", outputType, data, extraInfo);
        },
        getEventGroupsByMethod: function (onSuccess, onFailure, method, outputType, data, extraInfo) {
            if (typeof onSuccess != "function")
                return null;
            if ((typeof outputType == "undefined") || (outputType == null))
                outputType = "dgrid";

            var url = Librarian.path.getEventUrl(method) + "&out=" + outputType;

            if (extraInfo != null) {
                url += "&exi=" + extraInfo;
            }

            var options = {
                url: url,
                onSuccess: onSuccess,
                onFailure: function(error) {
                    Librarian.Utils.onFailure(error);
                    if (typeof onFailure == "function")
                        onFailure();
                }
            };

            if (data) {
                // If the given data is an object, stringify it
                if (typeof data == "object")
                    data = JSON.stringify(data);
                // Convert the data to Base64
                if (typeof Base64 != "undefined")
                    data = Base64.encode(data);

                // And save it
                options.data = data;
                options.method = "post";
                options.url += "&in=cjson";
            }

            var request = new Librarian.Request.JSON(options);
            request.send();

            return request;
        },
        getFilesByMethod: function (count, onSuccess, onFailure, method, type, outputType, parameters, useGetSendData, customSendData) {
            if (count <= 0)
                return null;
            if (typeof onSuccess != "function")
                return null;
            if ((typeof outputType == "undefined") || (outputType == null))
                outputType = "dgrid";
            if (typeof useGetSendData != "boolean")
                useGetSendData = true;

            var url = Librarian.path.getMethodUrl(method) + "&max=" + count + "&out=" + outputType + "&in=ujson";

            // If we were given parameters
            if ((typeof parameters == "object") && (parameters != null)) {
                // Add each one
                for (var key in parameters) {
                    if (!parameters.hasOwnProperty(key))
                        continue;

                    url += '&' + key + '=' + encodeURIComponent(parameters[key]);
                }
            }

            var view = '';
            if (Librarian.search.viewNameByType && Librarian.search.viewNameByType[type])
                view = "&vname=" + Librarian.search.viewNameByType[type];

            if (Librarian.elasticSearch.enableContent) {
                url += "&usees=1";

                if (Librarian.elasticSearch.includeView)
                    url += view;
            }
            else
                url += view;

            var options = {
                url: url,
                onSuccess: onSuccess,
                onFailure: function(error) {
                    Librarian.Utils.onFailure(error);
                    if (typeof onFailure == "function")
                        onFailure();
                }
            };

            // If we have a custom data function
            if (useGetSendData && (typeof Library != "undefined") && ((typeof Library.getSendData == "function") || (typeof customSendData == "function"))) {
                var data = {};
                if (type == Librarian.Search.outputTypes.FILES)
                    data.cattype = Librarian.catType.file;
                else if (type == Librarian.Search.outputTypes.GROUPS)
                    data.cattype = Librarian.catType.globalFavorite;

                // Get the data to send and check that it is valid
                if ((typeof customSendData == "function")) {
                    data = customSendData(data, options.url);
                } else {
                    data = Library.getSendData(data, options.url);
                }

                if (data) {
                    // If the given data is an object, stringify it
                    if (typeof data.data == "object")
                        data.data = JSON.stringify(data.data);
                    // Convert the data to Base64
                    if (typeof Base64 != "undefined")
                        data.data = Base64.encode(data.data);

                    // And save it
                    options.data = data.data;
                    options.method = "post";
                    if (data.url)
                        options.url = data.url;
                }
            }

            var request = new Librarian.Request.JSON(options);
            request.send();

            return request;
        },
        getNthBusinessDay: function (n, startDate) {
            if ((typeof n != "number") || (n <= 0))
                return null;

            if (!startDate)
                startDate = new Date();

            var targetDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());

            while (n > 0) {
                targetDate.setDate(targetDate.getDate() + 1);

                // Skip Sunday(0) and Saturday(6)
                var dayOfWeek = targetDate.getDay();
                if (dayOfWeek == 0 || dayOfWeek == 6)
                    continue;

                // Skip holidays
                if (Librarian.Utils.isHoliday(targetDate))
                    continue;

                // Otherwise, count this as a business day
                n--;
            }

            return targetDate;
        },
        getTopics: function(count, onSuccess, onFailure) {
            var url = Librarian.path.getCollaborationUrl("gettopics") + "&max=" + count + "&out=cjson" + "&in=cjson",
                options = {
                    url: url,
                    onSuccess: onSuccess,
                    onFailure: function(error) {
                        Librarian.Utils.onFailure(error);
                        if (typeof onFailure == "function")
                            onFailure();
                    }
                };

            var request = new Librarian.Request.JSON(options);
            request.send();
        },
        isHoliday: function (date) {
            var holidays = Librarian.calendar.holidays;
            if (!holidays)
                return false;

            for (var i = 0; i < holidays.length; i++) {
                var holiday = new Date(holidays[i]);

                if (date.getMonth() == holiday.getMonth() &&
                    date.getDate() == holiday.getDate() &&
                    (date.getFullYear() == holiday.getFullYear() ||
                        holiday.getFullYear() <= 2000)) // Holidays with same date every year
                    return true;
            }

            return false;
        },
        getFavoriteInstanceCount: function (presId, onComplete) {
            var request = new Librarian.Request({
                url: Librarian.path.getMethodUrl("getvpic") + "&pid=" + presId + "&out=ujson",
                onSuccess: onComplete,
                onFailure: Librarian.Utils.onFailure
            });
            request.send();
            return request;
        },
        reloadThumbnails: function () {
            // Reload the tilelist thumbnails
            if ((typeof tileList != "undefined") && (tileList != null))
                tileList.reloadThumbnails();
            if ((typeof tileList2 != "undefined") && (tileList2 != null))
                tileList2.reloadThumbnails();
            if ((typeof sectionList != "undefined") && (sectionList != null))
                sectionList.reloadThumbnails();
            if (Librarian.cartWindow && Librarian.cartWindow.cartList != null)
                Librarian.cartWindow.cartList.reloadThumbnails();
        },
        updateAllCheckboxes: function () {
            if ((typeof tileList != "undefined") && (tileList != null))
                Librarian.Utils.updateCheckboxes(tileList.getItemStyle());
            if ((typeof fileList != "undefined") && (fileList != null))
                Librarian.ListView.updateCartCheckBoxes.bind(fileList)();
            if (typeof Library.updateCheckboxes == "function")
                Library.updateCheckboxes();
            if (Librarian.SearchResult != null && Librarian.SearchResult.resultViews != null) {
                Array.each(Librarian.SearchResult.resultViews, function (view) {
                    view.updateCartCheckBoxes();
                });
            }
        },
        updateCheckboxes: function (styleName) {
            var elements = $$('.' + styleName),
                fromCart = styleName.contains("-cart");

            for (var i = 0; i < elements.length; i++) {
                if ((elements[i].enabled == false) || !elements[i].tileItem.cartCheckEl || (elements[i].tileItem.cartCheckEl.get("enabled") == "false") || !Librarian.userCart)
                    continue;

                if (Librarian.userCart.isInCart(elements[i].tileItem.data, !fromCart)) {
                    elements[i].tileItem.checked = true;

                    if (Librarian.tileList.enableHoverMenu)
                        elements[i].tileItem.cartCheckEl.show();
                    else
                        elements[i].tileItem.cartCheckEl.set("checked", true);
                }
                else {
                    elements[i].tileItem.checked = false;

                    if (Librarian.tileList.enableHoverMenu)
                        elements[i].tileItem.cartCheckEl.hide();
                    else
                        elements[i].tileItem.cartCheckEl.set("checked", false);
                }
            }
        },
        setButtonState: function (itemEl, wrapperEl, disable) {
            if (!itemEl)
                return;

            if (disable) {
                if (itemEl.src) {
                    // This item is already grayed out.
                    if (itemEl.src.contains("_gray"))
                        return;
                    // There are no "checked gray" images
                    if (itemEl.src.contains("_checked"))
                        return;

                    // Get the index of the last . so we can get the extension
                    var extIndex = itemEl.src.lastIndexOf('.');
                    // Get the extension from the src
                    var ext = itemEl.src.substring(extIndex + 1, itemEl.src.length);

                    // If we don't have a stored original src, store the current src.
                    if ((itemEl.src_orig == undefined) || (itemEl.src_orig == null))
                        itemEl.src_orig = itemEl.src;

                    // Change the src to the gray image
                    itemEl.src = itemEl.src.substring(0, extIndex) + "_gray." + ext;
                }

                itemEl.addClass("disabled");
                if (wrapperEl)
                    wrapperEl.addClass("disabled");
            }
            else {
                // Only switch everything back if there is an original src to switch back to
                if ((itemEl.src_orig != undefined) && (itemEl.src_orig != null))
                    itemEl.src = itemEl.src_orig;

                itemEl.removeClass("disabled");
                if (wrapperEl)
                    wrapperEl.removeClass("disabled");
            }
        },
        setButtonDisabled: function (buttonEl, disable) {
            Librarian.Utils.setElementDisabled(buttonEl, disable);
        },
        setElementDisabled: function (itemEl, disable, recursive) {
            if (!itemEl)
                return;
            if ((typeof disable == "undefined") || (disable == null))
                disable = true;

            itemEl.disabled = disable;

            if (disable)
                itemEl.addClass("disabled");
            else
                itemEl.removeClass("disabled");

            if (recursive) {
                var children = itemEl.getElements("*");
                children.forEach(function (childEl) {
                    Librarian.Utils.setElementDisabled(childEl, disable);
                });
            }
        },
        setTreeFileDisplay: function (show) {
            Librarian.Utils.runOnAllTrees((show ? "show" : "hide") + "Files");
        },
        unselectAllTrees: function () {
            Librarian.Utils.runOnAllTrees("unselect");
            Librarian.Utils.unselectAllWorkspaces();
        },
        runOnAllTrees: function (funcName) {
            var trees = Librarian.treeViews;
            for (var treeName in trees) {
                if (!trees.hasOwnProperty(treeName))
                    continue;

                var tree = trees[treeName];
                if (tree != null) {
                    if (typeof funcName == "function")
                        funcName(tree);
                    else if (typeof funcName == "string")
                        tree[funcName]();
                }
            }
        },
        unselectAllWorkspaces: function () {
            $$(".request-tree-label-selected").removeClass("request-tree-label-selected");
            $$(".upload-tree-label-selected").removeClass("upload-tree-label-selected");
            $$(".proc-tree-label-selected").removeClass("proc-tree-label-selected");
            $$(".myFilesLinkLabel-tree-label-selected").removeClass("myFilesLinkLabel-tree-label-selected");
            $$(".bookmark-tree-label-selected").removeClass("bookmark-tree-label-selected");
        },
        // Load the category given in the path
        loadCategoryByPath: function (path) {
            // Try selecting the path in the tree, if that fails, loads the category
            Librarian.Utils.selectTreeNodeByPath(treeView, path, null, true, function () {
                Librarian.Utils.getCatFromPath(path, function (data) {
                    Library.loadItemView(Object.toLowerKeys(data), data.name, data.description, data.type, tileList);
                });
            });
        },
        // Should be called load folder by name, doesn't accept a path
        loadFolderByPath: function (namedPath, catType, tree) {
            if ((typeof catType == "undefined") || (catType == null))
                catType = Librarian.catType.file;
            if ((typeof tree == "undefined") || (tree == null)) {
                if (typeof Library.getTreeByType == "function")
                    tree = Library.getTreeByType(catType);
                else
                    tree = treeView;
            }

            Librarian.Utils.getPath({ path: namedPath, type: (catType || Librarian.catType.file) }, function (path) {
                if (path == null) {
                    Librarian.Utils.error("Could not find path in library:\n" + namedPath);
                    return;
                }

                Librarian.Utils.selectTreeNodeByPath(tree, path);
            });
        },
        selectTreeNodeByPath: function (tree, path, start, useName, onFailure) {
            if (!tree)
                return;
            if ((typeof path == "undefined") || (path == null) || (path.length == 0))
                return;
            if ((typeof start == "undefined") || (start == null))
                start = true;
            if ((typeof useName == "undefined") || (useName == null))
                useName = false;

            Librarian.treeView.hasSelectionFinished = false;

            // If the tree isn't loaded
            if (!tree.loaded) {
                tree.recurseData = {
                    path: path,
                    start: start,
                    useName: useName
                };

                // Wait until it IS loaded
                Librarian.Utils.runFunctionOnTreeEvent(tree, "load", function () {
                    // If there is a root is it hasn't loaded
                    if (this.root && !this.root.isLoaded()) {
                        // Wait until IT is loaded
                        Librarian.Utils.runFunctionOnTreeEvent(this.root, "load", function () {
                            // And then finally run this function
                            Librarian.Utils.selectTreeNodeByPath(this.tree, this.tree.recurseData.path, this.tree.recurseData.start, this.tree.recurseData.useName, onFailure);
                        });
                    }
                    // Otherwise, try running the function now
                    else
                        Librarian.Utils.selectTreeNodeByPath(this, this.recurseData.path, this.recurseData.start, this.recurseData.useName, onFailure);
                });
                return;
            }
            else if (!tree.root.isOpen())
                tree.root.toggle(true);

            // Split the string into a list
            if (typeof path == "string")
                path = path.split('/');

            for (var i = 0; i < path.length; i++) {
                // Get the selected node in the tree
                var parent = tree.getSelected();
                // If there is no selected node, try the root
                if (!parent || start)
                    parent = tree.root;
                // In deep links the "parent" isn't really a node so we need to get the first real node
                if (!parent.data)
                    parent = parent.children[0];

                var parentData = null,
                    // Default to assuming this is a file
                    treeData = "fileid";
                // But if we're told to use names, check that instead
                if (useName)
                    parentData = parent.property.name;
                else {
                    // If it starts with a C, though, it's a category
                    if (path[i].startsWith("C")) {
                        // Trim off the C
                        path[i] = path[i].substring(1);
                        // And store the catid property as the key
                        treeData = "catid";
                    }
                    // If it starts with a E, though, it's an event
                    else if (path[i].startsWith("E")) {
                        // Trim off the C
                        path[i] = path[i].substring(1);
                        // And store the eventid property as the key
                        treeData = "eventid";
                    }

                    parentData = parent.data[treeData];
                }

                // Check this node to see if it's the one we're looking for
                if (parentData == path[i]) {
                    if (parent != tree.getSelected()) {
                        // If this isn't the last item in the path
                        if (i != (path.length - 1)) {
                            // Chop this item off the beginning of the path list
                            parent.path = path.slice(i + 1);
                            parent.useName = useName;
                            // Set open to false so that we force it open
                            parent.state.open = false;
                            Librarian.Utils.handleTreeToggleAndLoad(parent, function () {
                                this.tree.select(this);

                                // Once the node is loaded and open, keep searching if there
                                // are things left to search for
                                if (this.path.length > 0)
                                    Librarian.Utils.selectTreeNodeByPath(this.tree, this.path, false, this.useName, onFailure);
                            });

                            // Don't continue. Regardless of whether the parent is already loaded or open
                            // the inner function will be called, causing a recursive call to this function.
                            // If we continue, we will end up with two parallel recursive loading branches
                            return;
                        }
                        else {
                            // Only let the PageHeader load if this is the last item in the path
                            Librarian.treeView.hasSelectionFinished = true;
                            tree.select(parent);
                        }
                    }

                    // If this is the end of the path,
                    // return here so the "Cannot find this item" message isn't displayed
                    if (i == (path.length - 1))
                        return;
                    else
                        continue;
                }

                // Get the children for this node
                var children = parent.getChildren();
                // If there aren't any, bail
                if (!children)
                    return;

                // Check every child
                for (var j = 0; j < children.length; j++) {
                    var childData = null;
                    if (useName)
                        childData = children[j].property.name;
                    else
                        childData = children[j].data[treeData];

                    // If the id matches
                    if (childData == path[i]) {
                        // Only let the PageHeader load if this is the last item in the path
                        if (i == (path.length - 1))
                            Librarian.treeView.hasSelectionFinished = true;

                        // If we're checking file data and this is actually a file, select it
                        if ((treeData != "catid") && (typeof children[j][treeData] != "undefined")) {
                            tree.select(children[j]);

                            // If this is the end of the path,
                            // return here so the "Cannot find this item" message isn't displayed
                            if (i == (path.length - 1))
                                return;
                            else
                                break;
                        }

                        // Chop this item off the beginning of the path list
                        children[j].path = path.slice(i + 1);
                        children[j].useName = useName;
                        // Set open to false so that we force it open
                        children[j].state.open = false;
                        Librarian.Utils.handleTreeToggleAndLoad(children[j], function () {
                            this.tree.select(this);

                            // Once the node is loaded and open, run keep searching if there
                            // are things left to search for
                            if (this.path.length > 0)
                                Librarian.Utils.selectTreeNodeByPath(this.tree, this.path, false, this.useName, onFailure);
                        });

                        // Don't continue. Regardless of whether the node is already loaded or open
                        // the inner function will be called, causing a recursive call to this function.
                        // If we continue, we will end up with two parallel recursive loading branches
                        return;
                    }
                }
            }

            // Selection has finished, we just didn't find anything
            Librarian.treeView.hasSelectionFinished = true;
            // If we have gotten here, the thing we're looking for doesn't exist in the tree
            if (typeof onFailure == "function")
                onFailure();
            else
                Librarian.Utils.error(Librarian.Lang.getString("cantfindintree"));
            tree.unselect();

            // Load the home page as the default if we can't find this thing in the tree
            if (typeof Library.showHomePage == "function")
                Library.showHomePage();
            else if (typeof showHomePage == "function")
                showHomePage();
        },
        handleTreeToggleAndLoad: function (node, fn) {
            if (!node)
                return;
            if (typeof fn != "function")
                return;

            // If the node isn't loaded, load it, if it's a category
            else if (!node.isLoaded() && node.data && (node.data.fileid == null)) {
                Librarian.Utils.runFunctionOnTreeEvent(node, "load", function () {
                    // Now that it's loaded, open it
                    Librarian.Utils.handleTreeToggleAndLoad(this, fn);
                });

                if (!node.$loading) {
                    node.load();
                }
            }
            // If it is loaded, just make sure it's opened (if it can be)
            else if (!node.isOpen() && node.hasChildren()) {
                Librarian.Utils.runFunctionOnTreeEvent(node, "toggle", fn);
                node.toggle(true);
            }
            else
                fn.bind(node)();
        },
        runFunctionOnTreeEvent: function (node, eventName, fn) {
            if (!node)
                return;
            if (typeof eventName != "string")
                return;
            if (typeof fn != "function")
                return;

            function onEvent() {
                node.removeEvent(eventName, onEvent);
                fn.bind(node)();
            }

            node.addEvent(eventName, onEvent);
        },
        setSelectValue: function (selectEl, values, predicate) {
            if ((typeof selectEl == "undefined") || (selectEl == null))
                return -1;
            if ((typeof values == "undefined") || (values == null))
                return -1;

            // Make sure values is an array so we can support multi-select selects
            if (!(values instanceof Array))
                values = [values];

            var found = false;
            // De-select every option before checking
            for (var i = 0; i < selectEl.options.length; i++) {
                selectEl.options[i].selected = false;

                // Check each value, if this isn't a multi-select it will return after the first found
                for (var j = values.length; j--;) {
                    var value = values[j];
                    if ((selectEl.options[i].value == value) && ((typeof predicate != "function") || predicate(selectEl.options[i]))) {
                        if (!selectEl.multiple) {
                            selectEl.selectedIndex = i;
                            return i;
                        }

                        selectEl.options[i].selected = true;
                        found = true;
                        break;
                    }
                }
            }

            return found || -1;
        },
        getSelectedItem: function (selectEl) {
            if ((typeof selectEl == "undefined") || (selectEl == null))
                return null;

            var selectedIndex = selectEl.selectedIndex;
            if ((selectedIndex < 0) || (selectedIndex >= selectEl.options.length))
                return null;

            return selectEl.options[selectedIndex];
        },
        getSelectedValue: function (selectEl) {
            if (!selectEl)
                return null;

            var multiple = selectEl.get("multiple");
            if (multiple) {
                var values = [],
                    options = selectEl.options;
                for (var i = options.length; i--;) {
                    if (options[i].selected)
                        values.push(options[i].value);
                }
                return values;
            }

            var itemEl = Librarian.Utils.getSelectedItem(selectEl);
            return itemEl ? itemEl.value : null;
        },
        setElementValue: function (elementEl, value) {
            if ((typeof elementEl == "undefined") || (elementEl == null))
                return;
            if ((typeof value == "undefined") || (value == null))
                return;

            if (elementEl.tagName == "INPUT") {
                if ((elementEl.type == "checkbox") || (elementEl.type == "radio")) {
                    elementEl.set("checked", (value === true) || ((value + '') === "true"));
                }
                else
                    elementEl.value = value;
            }
            else if (elementEl.tagName == "SELECT")
                Librarian.Utils.setSelectValue(elementEl, value);
            else if (elementEl.tagName == "TEXTAREA") {
                // Make sure both of these are set so all browsers will recognize it
                elementEl.innerText = value;
                elementEl.value = value;
            }
            else
                elementEl.set("text", value);
        },
        getElementValue: function (elementEl, getCheckValue, returnNullIfUncheck) {
            if ((typeof elementEl == "undefined") || (elementEl == null))
                return null;

            // Make sure IE8 isn't being stupid
            elementEl = $(elementEl);

            if (elementEl.tagName == "INPUT") {
                if (!getCheckValue && ((elementEl.type == "checkbox") || (elementEl.type == "radio"))) {
                    return elementEl.get("checked");
                }
                else {
                    if (returnNullIfUncheck && (elementEl.type == "checkbox") || (elementEl.type == "radio")) {
                        var isChecked = elementEl.get("checked");
                        return isChecked ? elementEl.value : null;
                    }
                    else {
                        return elementEl.value;
                    }            
                }
                    
            }
            else if (elementEl.tagName == "SELECT")
                return Librarian.Utils.getSelectedValue(elementEl);
            else if (elementEl.tagName == "TEXTAREA")
                return elementEl.value || elementEl.innerText;

            return elementEl.get("text");
        },
        validateInputPattern: function(inputEl, ignoreEmpty) {
            var value = inputEl.value;
            if (!value && ignoreEmpty)
                return true;

            var pattern = inputEl.pattern;
            if (!pattern)
                return true;

            var regex = new RegExp(pattern);

            return regex.test(value);
        },
        fillSelect: function (selectEl, options, allowEmpty, clearFirst) {
            if (!selectEl)
                return;
            if ((typeof options == "undefined") || (options == null))
                return;
            if ((typeof allowEmpty == "undefined") || (allowEmpty == null))
                allowEmpty = false;
            if ((typeof clearFirst == "undefined") || (clearFirst == null))
                clearFirst = false;

            if (clearFirst) {
                selectEl.empty();
                selectEl.options.length = 0;
            }

            for (var i = 0; i < options.length; i++) {
                var name,
                    value,
                    disabled = false;

                if (typeOf(options[i]) == "array") {
                    name = (options[i][0] || '').trim();
                    value = (options[i][1] || '').trim();
                }
                else if (typeOf(options[i]) == "object") {
                    name = options[i].name;
                    value = options[i].id || name;
                    disabled = !!options[i].disabled;
                }
                else {
                    name = options[i];
                    value = options[i];
                }

                if (!allowEmpty && (name.length == 0) && (value.length == 0))
                    continue;

                var optionEl = new Option(name, value);
                if (disabled)
                    optionEl.disabled = disabled;
                selectEl.options.add(optionEl);
            }
        },
        limitValueLength: function (length) {
            if (this.value.length > length) {
                Librarian.Utils.error(Librarian.Lang.getArgString("max_length", [length]));
                // Cancel keyhit
                this.value = this.value.substring(0, length);
            }
        },
        setValueLengthLabel: function (countLimit, countContainerId) {
            if ((typeof countLimit != "number") || (typeof countContainerId != "string"))
                return;

            var count = (this.value || '').length,
                remaining = countLimit - count;

            Librarian.Utils.setElementValue($(countContainerId), remaining);
        },
        createLabeledInput: function (parentEl, id, type, name, value, label, checked, className, data, onClick, labelFunc) {
            if (!parentEl)
                return null;

            var contEl = new Element("div", {
                "class": className + "-container"
            }).injectInside(parentEl);

            var labelEl = new Element("label", {
                "class": className + "-label",
                "for": id
            }).injectInside(contEl);

            var childEl = new Element("input[type=" + type + "]", {
                "id": id,
                "class": className,
                "name": name,
                "value": value,
                "checked": (checked ? "checked" : '')
            }).injectInside(labelEl);

            if (typeof onClick == "function")
                childEl.addOnClick(onClick, childEl);

            // Set extra data if there is any
            if (data) {
                for (var key in data) {
                    if (data.hasOwnProperty(key))
                        childEl.set(key, data[key]);
                }
            }

            var labelNodeEl;
            if (labelFunc) {
                labelNodeEl = labelFunc(name, value, label);
            }
            else {
                labelNodeEl = document.createTextNode(label);
            }

            labelEl.appendChild(labelNodeEl);

            return contEl;
        },
        clearSearchRequests: function () {
            if (Librarian.contentLoader && Librarian.contentLoader.lastRequest) {
                Librarian.contentLoader.lastRequest.cancel();
                Librarian.contentLoader.lastRequest = null;
            }

            if (Librarian.lastSearch) {
                Librarian.lastSearch.cancel();
                Librarian.lastSearch.destroy();
                Librarian.lastSearch = null;
            }
        },
        clearRequests: function () {
            if (Librarian.myProcView != null) {
                Librarian.myProcView.enabled = false;

                if (Librarian.myProcView.request) {
                    Librarian.myProcView.request.cancel();
                    Librarian.myProcView.request = null;
                }

                // Don't stop this request, but stop it from reloading the table when it finishes.
                if (Librarian.myProcView.deleteRequest)
                    Librarian.myProcView.deleteRequest.onSuccess = function () { };
            }

            if (Librarian.myInProgProcView != null) {
                Librarian.myInProgProcView.enabled = false;

                if (Librarian.myInProgProcView.request) {
                    Librarian.myInProgProcView.request.cancel();
                    Librarian.myInProgProcView.request = null;
                }
            }
        },
        clearFocus: function () {
            Librarian.Utils.runOnAllTrees(function (tree) {
                if (tree != null && tree.keyNav)
                    tree.keyNav.detach();
            });
        },
        checkString: function (string) {
            for (var i = 0; i < string.length; i++) {
                if (Librarian.path.badChars.contains(string.charAt(i)))
                    return false;
            }

            return true;
        },
        scrubString: function (string, replacement) {
            replacement = replacement || '_';
            string = string || '';

            for (var i = 0; i < string.length; i++) {
                if (Librarian.path.badChars.contains(string.charAt(i)))
                    string = string.setCharAt(i, replacement);
            }

            return string;
        },
        undecorateFileName: function (name) {
            if (!name || !name.contains('@'))
                return name;

            // Get the index of the @
            var atIndex = name.indexOf('@'),
                // Find the _ that separates the e-mail from the file name
                underscoreIndex = name.indexOf('_', atIndex);
            // If it exists, chop everything up to that point
            if (underscoreIndex >= 0)
                name = name.substring(underscoreIndex + 1, name.length);

            return name;
        },
        loadCustomXML: function (path) {
            var xhttp;

            if (window.XMLHttpRequest)
                xhttp = new XMLHttpRequest();
            else
                xhttp = new ActiveXObject("Microsoft.XMLHTTP");

            xhttp.open("GET", path, false);
            xhttp.send();

            if (xhttp.status != 200)
                return null;

            var xml = xhttp.responseXML;

            xhttp = null;

            // CLN-840 - Workaround for IE10 and higher no longer having direct XPath support
            // This forces the use of the ActiveX XML DOM which still supports the needed methods
            // CLN-1470 - Workaround for Chrome having the same issue as newer IE
            if ((Browser.ie && (Browser.version > 9)))
                xml = Librarian.Utils.getXMLDoc(Librarian.Utils.getXMLText(xml));

            return xml;
        },
        getXMLDoc: function (xmlText) {
            var doc;

            if (window.DOMParser && !Browser.ie) {
                var parser = new DOMParser();
                doc = parser.parseFromString(xmlText, "text/xml");
            }
            else {
                doc = new ActiveXObject("Microsoft.XMLDOM");
                doc.async = "false";
                doc.preserveWhiteSpace = true;
                doc.loadXML(xmlText);
            }
            return doc;
        },
        createXMLDoc: function (rootName) {
            return Librarian.Utils.getXMLDoc('<' + rootName + "></" + rootName + '>');
        },
        getXMLText: function (xmlDoc) {
            var xml = xmlDoc.xml;

            // If there is no "xml" element, we have to serialize it ourselves
            if (xml == undefined) {
                // Make sure there IS a serializer.
                if (XMLSerializer) {
                    // And get the xml string from the document
                    var serializer = new XMLSerializer();
                    xml = serializer.serializeToString(xmlDoc);

                    serializer = null;
                }
            }

            return xml;
        },
        getXMLNodeText: function (nodeEl) {
            if (!nodeEl)
                return null;

            var text = nodeEl.text;
            if (typeof text != "string")
                text = nodeEl.textContent;
            if (typeof text != "string") {
                if (!nodeEl.get)
                    return null;
                text = nodeEl.get("text");
            }

            return text;
        },
        setXMLNodeText: function (nodeEl, text) {
            if (!nodeEl)
                return;

            if (!nodeEl.text) {
                if (nodeEl.set)
                    nodeEl.set("text", text);
            }
            else
                nodeEl.text = text;
        },
        getAttributeXMLNode: function (xmlDoc, attributeType, name, value) {
            var attribEl = xmlDoc.createElement(attributeType),
                nameEl = attribEl.appendChild(xmlDoc.createElement("Name")),
                valueEl = attribEl.appendChild(xmlDoc.createElement("Value"));

            nameEl.appendChild(xmlDoc.createTextNode(name));
            valueEl.appendChild(xmlDoc.createTextNode(value));

            return attribEl;
        },
        cloneXMLNode: function (xmlDoc, nodeEl, value) {
            var clonedEl = xmlDoc.createElement(nodeEl.nodeName);
            if ((typeof value != "undefined") && (value != null))
                clonedEl.appendChild(xmlDoc.createTextNode(value));

            for (var k = nodeEl.attributes.length; k--;)
                clonedEl.setAttribute(nodeEl.attributes[k].name, nodeEl.attributes[k].text || nodeEl.attributes[k].value);

            for (var l = nodeEl.childNodes.length; l--;) {
                if (nodeEl.childNodes[l].nodeName == "#text") {
                    var nodeText = Librarian.Utils.getXMLNodeText(nodeEl.childNodes[l]);
                    if (nodeText != null)
                        clonedEl.appendChild(xmlDoc.createTextNode(nodeText));
                }
                else
                    clonedEl.appendChild(Librarian.Utils.cloneXMLNode(xmlDoc, nodeEl.childNodes[l]));
            }

            return clonedEl;
        },
        cloneXMLDoc: function (xmlDoc) {
            var xml = Librarian.Utils.getXMLText(xmlDoc),
                newXMLDoc;

            if (window.DOMParser && !Browser.ie) {
                var parser = new DOMParser();
                newXMLDoc = parser.parseFromString(xml, "text/xml");

                parser = null;
            }
            // Internet Explorer
            else {
                newXMLDoc = new ActiveXObject("Microsoft.XMLDOM");
                newXMLDoc.async = "false";
                newXMLDoc.loadXML(xml);
            }

            return newXMLDoc;
        },
        doesXMLHaveNode: function (nodeEl, nodeName) {
            return nodeEl.getElementsByTagName(nodeName).length > 0;
        },
        getOrAddXMLNode: function(parentEl, name) {
            var nodeEl = Librarian.Utils.getXMLNode(parentEl, name);
            if (!nodeEl)
                nodeEl = Librarian.Utils.addXMLNode(parentEl, name);

            return nodeEl;
        },
        getXMLNode: function(parentEl, name) {
            return parentEl.getElementsByTagName(name)[0];
        },
        addXMLNode: function(parentEl, name, value) {
            var xmlDoc;
            if (parentEl instanceof XMLDocument) {
                xmlDoc = parentEl;
                parentEl = xmlDoc.documentElement;
            }
            else
                xmlDoc = parentEl.getDocument();

            var nodeEl = xmlDoc.createElement(name);
            parentEl.appendChild(nodeEl);

            if (value != null)
                nodeEl.set("text", value);

            return nodeEl;
        },

        // Adapted from https://davidwalsh.name/convert-xml-json
        // by David Walsh
        xmlToJson: function (xml) {
            var obj = {};

            if (xml.nodeType == 1) { // element
                if (xml.attributes.length > 0) {
                    obj["_attributes"] = {};
                    for (var j = 0; j < xml.attributes.length; j++) {
                        var attribute = xml.attributes.item(j);
                        obj["_attributes"][attribute.nodeName] = attribute.nodeValue;
                    }
                }
            }
            else if (xml.nodeType == 3) { // text
                obj = xml.nodeValue;
            }

            var elements = Array.from(xml.childNodes).filter(function (node) {
                return node.nodeType == 1;
            });

            if (elements.length > 0) {
                for (var i = 0; i < elements.length; i++) {
                    var item = elements[i],
                        nodeName = item.nodeName;

                    if (obj[nodeName] == null) {
                        // First child with this name
                        obj[nodeName] = this.xmlToJson(item);
                    } else {
                        // Create an array of children with the same name
                        if (obj[nodeName].push == null) {
                            var old = obj[nodeName];
                            obj[nodeName] = [];
                            obj[nodeName].push(old);
                        }

                        obj[nodeName].push(this.xmlToJson(item));
                    }
                }
            }
            else
                obj = xml.textContent;

            return obj;
        },
        renderContactName: function (data /*, row, colmod*/) {
            if (data.isgroup)
                return data.groupname || data.name;

            var name = '';

            if (data.firstname)
                name = data.firstname;

            if (data.lastname) {
                if (name.length > 0)
                    name += " ";

                name += data.lastname;
            }

            return name;
        },
        getContactNameClass: function(data) {
            if (data.isgroup)
                return "group-name";
            else
                return "contact-name";
        },
        isValidEmailAddress: function(email) {
            // text@text.text
            var regex = /[^<>()\s]+@[^<>()\s]+\.[^<>()\s]+/;

            return regex.test(email);
        },
        getLocalTimezoneName: function () {
            var dateString = new Date().toString();

            // Parse the timezone from the end of the date string
            // This works for Chrome and Firefox, but not IE
            var matches = /\((.*)\)/.exec(dateString);
            if (matches)
                return matches[1];

            return "";
        },
        getUTCDateValue: function (dateString, format) {
            var date = Librarian.Utils.extractDateFromString(dateString);
            if (!date || isNaN(date) || (date == "Invalid Date"))
                return null;

            date.increment("hour", -date.getGMTOffset().toInt() / 100);

            return Librarian.Utils.getDateValue(date, format);
        },
        getDateValue: function (dateString, format) {
            var date = Librarian.Utils.extractDateFromString(dateString);
            if (typeof format != "string")
                format = "%m/%d/%Y";

            if (!date || isNaN(date) || (date == "Invalid Date"))
                date = null;
            else
                date = date.format(format);

            return date;
        },
        extractDateFromString: function (dateString) {
            if (dateString instanceof Date)
                return dateString;

            if (dateString) {
                // Make sure this is actually a string
                dateString = dateString + '';

                // Datestring cannot be parsed correctly if it uses ".+" instead of "+"
                dateString = dateString.replace(".+", "+");

                if (dateString.contains("Date(")) {
                    var end = dateString.indexOf('-');
                    if (end < 0)
                        end = dateString.indexOf(')');

                    return eval("new " + dateString.slice(1, end) + ")");
                }
                else {
                    // Try to parse the date out as-is
                    var date = Date.parse(dateString);
                    // Newer browsers return a number from Date.parse
                    // If that is the case, convert it to a date object
                    if (typeof date == "number")
                        date = new Date(date);
                    // If that didn't work, it may be an ISO format in an older browser
                    // The fromISO function will also use the native Date constructor parsing if the string isn't in ISO format
                    if (isNaN(date))
                        date = Date.fromISO(dateString);
                    return date;
                }
            }

            return null;
        },
        setUpDatePicker: function (boxClass, boxId, iconId, parentId, onIconClick, options) {
            var picker = null;
            var dateFields = $$("input." + boxClass);
            if (dateFields.length > 0) {
                var defaultOptions = {
                    timePicker: false,
                    positionOffset: { x: 0, y: 0 },
                    pickerClass: "datepicker_vista",
                    useFadeInOut: false
                };

                picker = new Picker.Date(dateFields, Object.merge(defaultOptions, options));

                dateFields.each(function (el) {
                    el.removeClass(boxClass);
                });

                var calendarIconEl = $(parentId + '_' + iconId) || $(iconId);
                if (calendarIconEl) {
                    if ((typeof parentId == "string") && (parentId.length > 0))
                        calendarIconEl.id = parentId + '_' + iconId;
                    calendarIconEl.parentId = parentId;
                    calendarIconEl.boxId = boxId;
                    calendarIconEl.onIconClick = onIconClick;
                    calendarIconEl.src = Librarian.path.getDefaultThemePath() + "images/icons/calendar.gif";
                    calendarIconEl.addOnClick(function (e) {
                        var evt = new Event(e);
                        evt.stop();

                        if (typeof this.onIconClick == "function")
                            this.onIconClick();

                        var itemEl = $(this.parentId + '_' + this.boxId) || $(this.boxId);
                        if (itemEl && itemEl.isVisible())
                            itemEl.focus();

                        evt = null;
                    });
                }
            }

            return picker;
        },
        setUpDatePicker2: function (boxEl, iconEl, onIconClick, options) {
            var defaultOptions = {
                timePicker: false,
                positionOffset: { x: 0, y: 0 },
                pickerClass: "datepicker_vista",
                useFadeInOut: false,
                blockKeydown: false,
            };

            var picker = new Picker.Date(boxEl, Object.merge(defaultOptions, options));

            if (iconEl) {
                iconEl.boxEl = boxEl;
                iconEl.onIconClick = onIconClick;
                iconEl.addOnClick(function () {
                    if (typeof this.onIconClick == "function")
                        this.onIconClick();

                    if (this.boxEl)
                        this.boxEl.focus();

                    return false;
                });
            }

            return picker;
        },
        progressBar: function (target, width, height, colors, leftValue, totalValue, display) {
            var targetEl = $(target);
            if (!targetEl)
                return;

            // Clear out the target
            targetEl.empty();

            // Make sure these are valid boolean values
            display.percent = !!display.percent;
            display.lowerbound = !!display.lowerbound;
            display.upperbound = !!display.upperbound;
            display.leftvalue = !!display.leftvalue;
            display.rightvalue = !!display.rightvalue;

            var percent = Math.min((leftValue / totalValue), 1),
                leftWidth = percent * width,
                rightWidth = width - leftWidth,

                // Use a table to keep the correct layout
                tableEl = new Element("table"),
                bodyEl = new Element("tbody"),
                rowEl = new Element("tr"),
                leftColEl = new Element("td"),
                rightColEl = new Element("td"),
                percentColEl;

            // Create the left portion and fill it, but only if it will actually take up some space
            if (leftWidth > 0) {
                leftColEl.width = leftColEl.style.width = leftWidth + "px";
                leftColEl.height = leftColEl.style.height = height + "px";

                // Make sure the color exists before trying to use it
                if (colors.leftBackground != undefined)
                    leftColEl.style.backgroundColor = colors.leftBackground;

                rowEl.appendChild(leftColEl);
            }

            // Create the right portion and fill it, but only if it will actually take up some space
            if (rightWidth > 0) {
                rightColEl.width = rightColEl.style.width = rightWidth + "px";
                rightColEl.height = rightColEl.style.height = height + "px";

                // Make sure the color exists before trying to use it
                if (colors.rightBackground != undefined)
                    rightColEl.style.backgroundColor = colors.rightBackground;

                rowEl.appendChild(rightColEl);
            }

            bodyEl.appendChild(rowEl);

            // Show the current value on the left and the remaining value on the right
            if (display.rightvalue || display.leftvalue) {
                if (display.leftvalue)
                    leftColEl.set("text", leftValue);

                leftColEl.align = "center";
                leftColEl.style.color = colors.leftValue;

                if (display.rightvalue)
                    rightColEl.set("text", totalValue - leftValue);

                rightColEl.align = "center";
                rightColEl.style.color = colors.rightValue;
            }

            // Show 0 on the left and the total value on the right and the percent in the middle
            if (display.lowerbound || display.upperbound || display.percent) {
                var valueTableEl = new Element("table"),
                    valueBodyEl = new Element("tbody"),
                    valueRowEl = new Element("tr"),
                    colEl = new Element("td");
                leftColEl = new Element("td");
                rightColEl = new Element("td");
                percentColEl = new Element("td");
                rowEl = new Element("tr");

                valueTableEl.width = "100%";
                colEl.colSpan = '2';

                // Set up the new columns
                if (display.lowerbound)
                    leftColEl.set("text", 0);

                leftColEl.width = (.4 * width);

                if (display.upperbound)
                    rightColEl.set("text", totalValue);
                rightColEl.width = (.4 * width);
                rightColEl.align = "right";

                // If we're showing the percent, add that in the middle
                if (display.percent)
                    percentColEl.set("text", Math.ceil(percent * 100) + '%');

                // Always add the space for it, though, so the layout is consistent
                percentColEl.align = "center";
                percentColEl.width = 40;

                // Add it all to the table now
                valueRowEl.appendChild(leftColEl);
                valueRowEl.appendChild(percentColEl);
                valueRowEl.appendChild(rightColEl);
                valueBodyEl.appendChild(valueRowEl);
                valueTableEl.appendChild(valueBodyEl);
                colEl.appendChild(valueTableEl);
                rowEl.appendChild(colEl);
                bodyEl.appendChild(rowEl);
            }

            // Add everything to the table and add the table to the target
            tableEl.appendChild(bodyEl);
            targetEl.appendChild(tableEl);
        },
        prepareItemData: function (data, index, parentData, count, totalIndex) {
            var ext = Librarian.Utils.getExtensionFromData(data);
            data.ext = ext;

            // If there is no fileid provided, default to 0
            if (data.fileid == undefined)
                data.fileid = 0;
            // If there is no presid provided, default to 0
            if (data.presid == undefined)
                data.presid = 0;
            // If there is no groupid provided, default to 0
            if (data.groupid == undefined)
                data.groupid = 0;
            // If there is no slideid provided, default to 0
            if (data.slideid == undefined)
                data.slideid = 0;

            // If there is parent data
            if (parentData) {
                // and it provides the fileid, store it.
                if (parentData.fileid > data.fileid)
                    data.fileid = parentData.fileid;
                // and it provides the slideid, store it.
                if (parentData.slideid > data.slideid)
                    data.slideid = parentData.slideid;
                // and it provides the groupid, store it.
                if (parentData.groupid > data.groupid)
                    data.groupid = parentData.groupid;
                // and it provides the presid, store it.
                if (parentData.presid > data.presid)
                    data.presid = parentData.presid;

                // Pull the file type extension out from it if the child
                // doesn't have this information.
                if (data.filetypeextension == undefined)
                    data.filetypeextension = parentData.filetypeextension;
                // Pull the name out from it if the child
                // doesn't have a name.
                if (data.name == undefined)
                    data.name = parentData.name;
                // If this is a group, save the group name as the name of this item
                if ((data.groupid > 0) && parentData.name)
                    data.name = parentData.name;
                // If the child doesn't have a slidecount, pull it from
                // the length of the list of items.
                if (isNaN(data.slidecount)) {
                    if (!isNaN(parentData.pagecount) && (parentData.pagecount > 0))
                        data.slidecount = parentData.pagecount;
                    else if (!isNaN(data.pagecount) && (data.pagecount > 0) && (data.presid < 0))
                        data.slidecount = data.pagecount;
                    // Items that are pretending to have slides should have their slidecount be 0 unless they are in a My Favorite
                    else if ((!Librarian.extensions.hasFakeSlides(ext) || (data.presid > 0)) && !isNaN(count))
                        data.slidecount = count;
                    else
                        data.slidecount = 0;
                }

                // If the parent has extra fields but the child doesn't, copy them over
                if (parentData.extrafields && !data.extrafields)
                    data.extrafields = parentData.extrafields;
            }
            // If this is a child that doesn't have a slide count but does have a
            // PAGE count, set the slide count to the page count
            else if (isNaN(data.slidecount) && !isNaN(data.pagecount) && (data.pagecount > 0))
                data.slidecount = data.pagecount;
            else if (isNaN(data.slidecount) && !isNaN(count))
                data.slidecount = count;

            if (data.contenttype == Librarian.contentType.contentGroup) {
                // The "slidenumber" within a group refers to the slide number
                // from the source file. In order to avoid confusion, we use
                // an "itemnumber" property to define the slide number within this group.
                // Also, set the extension for the global here.
                if ((data.fileid > 0) && (data.itemnumber == null) && (typeof index == "number"))
                    data.itemnumber = index + 1;
                if (!data.sourceext)
                    data.sourceext = ext;
                data.filetypeextension = "favg";
            }
            else if (data.groupid > 0 && typeof data.eventcount == "number") {
                data.slidecount = data.eventcount;
                data.filetypeextension = "evtg";
            }
            // Set the extension for the virtual presentation
            else if (data.presid > 0) {
                if (!data.sourceext)
                    data.sourceext = ext;
                data.filetypeextension = "vpres";
                if ((typeof data.prestype != "number") && (parentData != null))
                    data.prestype = parentData.prestype;
                if (Librarian.Utils.isSlideShow(data)) {
                    if (data.slidecount <= 0)
                        data.slidecount = 1;
                    if ((typeof data.itemnumber != "number") || (data.itemnumber < 0))
                        data.itemnumber = 0;
                }
            }
            // Set the extension for events
            else if (data.eventid > 0) {
                data.filetypeextension = "evt";
                if (typeof totalIndex == "number")
                    data.eventnumber = totalIndex + 1;
                if (parentData && parentData.eventgroupinfo && (parentData.eventgroupinfo.eventcount > 0))
                    data.eventcount = parentData.eventgroupinfo.eventcount;
                else
                    data.eventcount = count;
            }

            // If we aren't given a slidenumber, this is a file and we should set it to 0.
            if (data.slidenumber == undefined)
                data.slidenumber = 0;

            // If this is a fake slide from a file within a my favorite, set the slide number to its item number so the cart doesn't think this is a file
            if ((data.presid > 0) && (data.slidenumber == -1) && Librarian.extensions.hasFakeSlides(ext))
                data.slidenumber = data.itemnumber;
        },
        showProgressImage: function (referenceEl) {
            var progressEl = new Element("img");
            progressEl.setStyles({
                paddingLeft: "5px",
                paddingTop: "5px",

                position: "absolute",
                zIndex: 5000
            });
            progressEl.id = "progressImage";

            progressEl.onload = function () {
                var parentEl = this.getParent();
                if (!parentEl)
                    return;

                var parentSize = parentEl.getSize();
                // Set the top and left position of the image to be right in the middle of the parent
                this.style.top = (parentSize.y / 2) - (this.getHeight() / 2) + "px";
                this.style.left = (parentSize.x / 2) - (this.getWidth() / 2) + "px";
            }.bind(progressEl);

            if ((typeof referenceEl != "undefined") && (referenceEl != null)) {
                progressEl.id = referenceEl.id + '_' + progressEl.id;
                referenceEl.appendChild(progressEl);
            }
            else
                document.body.appendChild(progressEl);

            progressEl.src = Librarian.path.getImagesPath() + "progress.gif";

            return progressEl.id;
        },
        hideProgressImage: function (id) {
            if ((typeof id == "undefined") || (id == null))
                id = "progressImage";

            var progressEl = $(id);
            if (progressEl)
                progressEl.destroy();
        },
        showModalCover: function (contEl) {
            if (!contEl)
                return null;

            var coverEl = new Element("div", {
                "class": "modal-cover",
                "styles": {
                    "height": contEl.getScrollHeight() + "px"
                }
            }).injectInside(contEl);

            return coverEl;
        },
        isPackageNameValid: function (name, notify) {
            name = (name || '').trim();
            if (name.length == 0) {
                if (notify !== false)
                    Librarian.Utils.error(Librarian.Lang.getArgString("create_namerequired", [Librarian.Lang.getString("presentation")]));
                return false;
            }

            if (!Librarian.Utils.checkString(name)) {
                if (notify !== false)
                    Librarian.Utils.error(Librarian.Lang.getArgString("create_invalidname", [Librarian.Lang.getString("presentation"), Librarian.path.badChars]));
                return false;
            }

            if (Librarian.path.badNames.contains(name)) {
                if (notify !== false)
                    Librarian.Utils.error(Librarian.Lang.getArgString("create_badname", Librarian.Lang.getString("presentation")));
                return false;
            }

            if (name.length > Librarian.path.maxFileNameLength) {
                if (notify !== false)
                    Librarian.Utils.error(Librarian.Lang.getArgString("create_nametoolong", [Librarian.Lang.getString("presentation"), Librarian.path.maxFileNameLength]));
                return false;
            }

            return true;
        },
        getItemInformation: function (data, onSuccess, onFailure) {
            if (typeof onSuccess != "function")
                return;

            var url = null;

            if (data.presid > 0)
                url = Librarian.path.getMethodUrl("getvp") + "&pid=" + data.presid + "&out=dgrid";
            else if (data.groupid > 0)
                url = Librarian.path.getMethodUrl("getgslides") + "&gid=" + data.groupid + "&out=dgrid&expand=" + (Librarian.tileList.expandGroupItemsToSlides ? '1' : '0');
            else if (data.fileid > 0)
                url = Librarian.path.getMethodUrl("getslides") + "&fid=" + data.fileid + "&out=dgrid";
            else if (data.catid != -1) {
                var type = data.type;

                if (type == Librarian.catType.myFavorite)
                    url = Librarian.path.getMethodUrl("getvpci") + "&cid=" + data.catid + "&out=dgrid";
                else if (type == Librarian.catType.globalFavorite)
                    url = Librarian.path.getMethodUrl("getcgci") + "&cid=" + data.catid + "&out=dgrid";
                else
                    url = Librarian.path.getMethodUrl("getci") + "&cid=" + data.catid + "&out=dgrid";
            }

            if (!url)
                return;

            var request = new Librarian.Request.JSON({
                url: url,
                onSuccess: onSuccess
            });
            if (typeof onFailure == "function")
                request.onFailure = onFailure;
            request.send();
        },
        logout: function () {
            var params = Librarian.features.sso.load ? "?sso=false" : "";

            Librarian.Utils.clearRequests();
            Librarian.Utils.clearSearchRequests();

            var session = new Librarian.Session();
            session.onLogoff = function () {
                // Remove session name from window
                var storedHash = window.name.parseQueryString();
                delete storedHash.sname;
                window.name = Object.toQueryString(storedHash);

                // Once logoff is complete, redirect
                Librarian.Utils.openPage("index.htm" + params, false);
            };
            session.onFailure = function (error) {
                // If we got a 401, we're not authenicated anyway
                // so just redirect
                if (error && (error.status == 401))
                    Librarian.Utils.openPage("index.htm" + params, false);
                // Otherwise, alert the error text
                else {
                    var index = this.response.text.indexOf('\n'),
                        message;
                    if (index > 0)
                        message = this.response.text.substr(0, index);
                    else
                        message = this.response.text;

                    if (message.length > 0)
                        Librarian.Utils.error(message, false);
                }
            };
            session.logoff();
        },
        openPage: function (page, keepHash, target) {
            if ((typeof keepHash == "undefined") || (keepHash == null))
                keepHash = true;
            if ((typeof target == "undefined") || (target == null))
                target = "_self";

            var hash = '';
            // If there is a hash on this url, keep it through the page load
            if (window.location.hash && keepHash)
                hash = window.location.hash;
            // If we're going to the login screen, keep the search path because it could contain "sso=true"
            if ((page == "index.htm") && window.location.search)
                page += window.location.search;

            // Add the build version to the end of the path to make sure it's unique and not cached, if it doesn't have it already
            if (!page.contains('?' + Librarian.buildVersion) && !page.contains('&' + Librarian.buildVersion))
                page += (page.contains('?') ? '&' : '?') + Librarian.buildVersion;

            window.open(page + Librarian.Utils.encodeHash(hash), target);
        },
        encodeHash: function (hash) {
            if (hash.length == 0)
                return hash;

            // Drop the # and split by all the &s
            var tags = hash.substring(1).split('&');

            // Go through each key-value pair
            for (var i = 0; i < tags.length; i++) {
                // Split by the = to separate the keys and values
                var values = tags[i].split('=');

                // Go through each key/value and encode it
                for (var j = 0; j < values.length; j++)
                    values[j] = encodeURIComponent(decodeURIComponent(values[j]));

                // Rejoin this key-value pair
                tags[i] = values.join('=');
            }

            // Rejoin the entire hash with & and prepend the #
            return '#' + tags.join('&');
        },
        loadHomeContent: function (onNoHash) {
            // Hash navigation doesn't work at all on IE7, so don't even try
            if ((Browser.ie7 || !Librarian.Utils.onHashChange(this.getHash(), true)) && (typeof onNoHash == "function"))
                onNoHash();
        },
        onHashChange: function (hash, forced) {
            // Hash navigation doesn't work at all on IE7, so don't even try
            if (Browser.ie7 || !Librarian.hashNavigation)
                return false;

            if (Librarian.forcedHashChange === true) {
                Librarian.forcedHashChange = false;
                return true;
            }

            if (hash.length > 1) {
                var data = hash.parseQueryString();
                //Vue route, handled in router.js. skey handled differently
                if (data.vuePage || data.skey) {
                    return true;
                }

                if (data.page != null) {
                    if (typeof Library.loadPageFromHash == "function")
                        return Library.loadPageFromHash(data);
                }

                // If this is a deeplink do a simple lookup
                // We can't do a server lookup because of the issue described in CLN-1311
                if (Librarian.isGuest) {
                    if (data.fileid > 0) {
                        var doLoad = function () {
                            var root = treeView.root,
                                openFile = function () {
                                    treeView.removeEvent("select", openFile);
                                    Librarian.Utils.selectTreeNodeByPath(treeView, 'E' + Librarian.eventInfo.EventId + '/' + data.fileid);
                                };
                            if (root && !root.data)
                                root = root.children[0];
                            // There is code in place to automatically select the root node for a deep link, wait for that to happen and then open the preview window
                            if (root && !root.state.open)
                                treeView.addEvent("select", openFile);
                            else
                                openFile();
                        };

                        // If the tree hasn't loaded yet, wait for it to do that
                        if (!treeView.loaded)
                            Librarian.Utils.runFunctionOnTreeEvent(treeView, "loadChildren", doLoad);
                        else
                            doLoad();

                        return true;
                    }
                    return false;
                }

                if (data.type == null)
                    data.type = 0;

                // If loading the path fails, use this as a fallback
                var itemLoadFallback = function () {
                    var list = tileList;
                    if (typeof Library.getListByType == "function")
                        list = Library.getListByType(this.type);

                    // Try to get the information about the item from the server
                    // This method looks the same as loading from the tree, but the
                    // actual item isn't selected in the tree
                    if (typeof Library.loadItemView == "function") {
                        Librarian.Utils.getItemInformation(data, function (json) {
                            if (!json || !json.data || (json.data.length == 0))
                                return;

                            var info = json.data[0];
                            // This is a file
                            if (info.fileinfo) {
                                info = info.fileinfo;
                                info.contenttype = Librarian.contentType.file;
                            }
                            // This is a content group
                            if (info.groupinfo) {
                                info = info.groupinfo;
                                info.contenttype = Librarian.contentType.globalFavorite;
                            }
                            // This is a virtual presentation
                            if (info.presid && info.items) {
                                info = Object.subset(info, ["name", "description", "presid", "slidecount", "createddate", "lastmoddate"]);
                                info.contenttype = Librarian.contentType.myFavorite;
                            }

                            var tree = Library.getTreeByType(this.type, this.tab, this.prestype);

                            Librarian.Utils.onTreeSelect.bind(tree)({ data: info, name: info.name }, list);
                        },
                        function() {
                            Librarian.Utils.error(Librarian.Lang.getString("cantfindintree"));
                            if (typeof Library.showHomePage == "function")
                                Library.showHomePage();
                            else if (typeof showHomePage == "function")
                                showHomePage();
                        }.bind(data));
                    }
                    // This is a last ditch effort to load the data
                    // This is just a blank list with the given information, no page header
                    else {
                        Librarian.contentLoader.onComplete = list.loadComplete;
                        Librarian.contentLoader.load(data, data.type);
                    }
                };

                // If we can get the tree, try to load the file/category by path
                if (typeof Library.getTreeByType == "function") {
                    Librarian.Utils.getPath(data, function (path) {
                        if (path != null)
                            Librarian.Utils.selectTreeNodeByPath(Library.getTreeByType(data.type, data.tab, data.prestype), path);
                        // If the path wasn't found, fall back
                        else
                            itemLoadFallback();
                    });
                }
                // Otherwise fall back
                else
                    itemLoadFallback();

                if (data.preview == "true")
                    Librarian.PreviewWindow.openPreviewWindow({
                        fileid: data.fileid
                    });

                return true;
            }

            // If this wasn't force loaded and there is a pageClick function,
            // load the home page beacuse we don't have a hash
            if (!Librarian.isGuest && (forced !== true)) {
                if (typeof Library.pageClick == "function") {
                    Library.pageClick("home");
                    return true;
                }
            }

            return false;
        },
        onTreeSelect: function (node, list, hashSuffix) {
            if (Librarian.hashNavigation)
                Librarian.Utils.changeTreeHash.bind(this)(node, hashSuffix);

            if (Librarian.myProcView != null)
                Librarian.myProcView.destroy();

            if (typeof Library.onTreeSelect == "function")
                Library.onTreeSelect.bind(this)(node, list);

            var mainPanelEl = $("mainPanel");
            if (mainPanelEl)
                mainPanelEl.scrollTo(0, 0);
            else
                window.scrollTo(0, 0);
        },
        changeTreeHash: function (node, hashSuffix) {
            var hash = '';

            if (node.data.fileid > 0) {
                if ((this.options.catType == Librarian.catType.globalFavorite) ||
                    (node.data.contenttype == Librarian.contentType.globalFavorite))
                    hash = "groupid=" + node.data.fileid;
                else if (this.options.catType == Librarian.catType.myFavorite)
                    hash = "presid=" + node.data.fileid;
                else if (this.options.catType == Librarian.catType.event)
                    hash = "groupid=" + node.data.fileid;
                else
                    hash = "fileid=" + node.data.fileid;
            }

            if (node.data.catid != null)
                hash += ((hash.length > 0) ? '&' : '') + "catid=" + node.data.catid;

            // Add the pres type as well
            if (node.data.prestype > 0)
                hash += "&prestype=" + node.data.prestype;

            hash += "&type=" + this.options.catType;

            // Save this setting so the Outlook plugin's portals can be special and use titles
            if (Librarian.isGuest && Librarian.tileList.useFileTitle)
                hash += "&useTitle=true";

            if (typeof hashSuffix == "string")
                hash += hashSuffix;

            Librarian.Utils.changeHash(hash);
        },

        changeHash: function (hash) {
            if (this.getHash() != hash) {
                Librarian.forcedHashChange = true;
                window.location.hash = hash;
            }

            // Make sure value is reset in case onHashChange is not triggered
            setTimeout(function() {
                Librarian.forcedHashChange = false;
            });
        },

        toggleListView: function (reload, saveUserSetting) {
            Librarian.listView.enabled = !Librarian.listView.enabled;
            if (saveUserSetting !== false)
                Librarian.Utils.setUserSetting(Librarian.ListView.enabledSetting, Librarian.listView.enabled);

            if (reload !== false) {
                if (!Librarian.search.isSearching) {
                    if ((Library.curPage == "home") && (typeof Library.loadHome == "function"))
                        Library.loadHome();
                    else {
                        if (Librarian.pageHeader && Librarian.pageHeader.options.headerType == Librarian.headerTypes.bookmark) {
                            Librarian.Bookmarks.viewBookmarkedContents();
                        } else {
                            var trees = Librarian.treeViews;
                            // Find the first tree with selection and run onTreeSelect on it
                            for (var treeName in trees) {
                                if (!trees.hasOwnProperty(treeName))
                                    continue;

                                var tree = trees[treeName];
                                if (tree != null) {
                                    var selected = tree.getSelected();
                                    if (selected) {
                                        Library.onTreeSelect.bind(tree)(selected, tileList, true);
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                else {
                    var search = Librarian.lastSearch,
                        maxResults = Librarian.search.maxResults;

                    if (Librarian.listView.enabled) {
                        Librarian.Search.showSearchNavigation(false);
                        maxResults = Librarian.ListView.prepSearchGrid(search, search.getOutputType());
                    }
                    else {
                        search.options.loadComplete = tileList.searchLoadComplete;
                        if (tileList && tileList.wrapper) {
                            tileList.reset();
                            tileList.wrapper.appendChild(document.createTextNode(Librarian.Lang.getString("searching")));
                        }
                    }

                    search.addResults(null, maxResults);
                    Librarian.lastSearch = search;
                    search.search();
                }
            }

            var itemEl = $("toggleList");
            if (itemEl) {
                if (Librarian.listView.enabled)
                    itemEl.set("text", "Thumbnail View");
                else
                    itemEl.set("text", "List View");
            }

            itemEl = $("expandCollapseContainer");
            if (itemEl) {
                if (Librarian.listView.enabled)
                    itemEl.show("inline");
                else
                    itemEl.hide();
            }

            itemEl = null;
        },
        toggleTagCloudView: function (enable, data) {
            if (!Librarian.features.tagcloud.load) {
                return;
            }

            if (enable) {
                //Hide related content
                var relatedContentEl = $("relatedContent");
                if (relatedContentEl) {
                    relatedContentEl.hide();
                }

                if (tileList) {
                    // Reset the TileList
                    tileList.reset();
                }

                if (Librarian.tagCloudView) {
                    Librarian.tagCloudView.reload(data);
                } else {
                    Librarian.tagCloudView = new Librarian.TagCloudView({
                        container: $("tileListWrapper"),
                        data: data
                    });
                }
            } else {
                if (Librarian.tagCloudView) {
                    if (Librarian.tagCloudView.isVisible()) {
                        Librarian.tagCloudView.clean();

                        if ((Library.curPage == "home") && (typeof Library.loadHome == "function"))
                            Library.loadHome();
                        else {
                            var trees = Librarian.treeViews;
                            // Find the first tree with selection and run onTreeSelect on it
                            for (var treeName in trees) {
                                if (!trees.hasOwnProperty(treeName))
                                    continue;

                                var tree = trees[treeName];
                                if (tree != null) {
                                    var selected = tree.getSelected();
                                    if (selected) {
                                        Library.onTreeSelect.bind(tree)(selected, tileList, true);
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        getStandardContent: function (content) {
            content = Object.toLowerKeys(content);

            // Standardize contentname
            content.contentname = content.name || content.contentname;

            // Standardize content type
            if (!content.contenttype) {
                if (content.slideid > 0)
                    content.contenttype = Librarian.contentType.slide;
                else if (content.groupid > 0) {
                    if (content.ext == "evtg")
                        content.contenttype = Librarian.contentType.eventGroup;
                    else
                        content.contenttype = Librarian.contentType.globalFavorite;
                }
                else if (content.presid > 0 && (content.ext == "vpres" || content.sourceext == null))
                    content.contenttype = Librarian.contentType.myFavorite;
                else if (content.fileid > 0 || content.fileId > 0)
                    content.contenttype = Librarian.contentType.file;
                else if (content.catid >= 0) {
                    content.contenttype = Librarian.contentType.category;

                    if ((content.cattype == Librarian.catType.myFavorite) || content.presentations)
                        content.contenttype = Librarian.contentType.myFavoriteCategory;
                }
            }

            // Standardize content id
            if (content.contenttype == Librarian.contentType.globalFavorite)
                content.contentid = content.groupid || content.fileid || content.contentid;
            else if (content.contenttype == Librarian.contentType.myFavorite)
                content.contentid = content.presid || content.fileid || content.contentid;
            else if (content.contenttype == Librarian.contentType.slide) {
                content.contentid = content.slideid || content.contentid;

                if (content.slidenumber && content.filename)
                    content.contentname = Librarian.Utils.getItemTypeString(content) + " " + content.slidenumber + " in " + content.filename;
            }
            else if (content.contenttype == Librarian.contentType.file) {
                content.contentid = content.fileid || content.fileId || content.contentid;
                content.contentname = content.filename || content.contentname;
            }
            else if ((content.contenttype == Librarian.contentType.category) || (content.contenttype == Librarian.contentType.myFavoriteCategory))
                content.contentid = (content.catid >= 0) ? content.catid : content.contentid;
            else if (content.contenttype == Librarian.contentType.eventGroup)
                content.contentid = content.groupid || content.contentid;

            return content;
        },
        getFromContent: function (content) {
            if (!content || !content.contentid || (typeof content.contenttype != "number") || !content.contentname)
                return content;

            var item = {
                contenttype: content.contenttype
            };

            if (content.contenttype == Librarian.contentType.slide) {
                item.slideid = content.contentid;
                item.filename = content.contentname;
                item.title = content.title;
            }
            else if (content.contenttype == Librarian.contentType.file) {
                item.fileid = content.contentid;
                item.filename = content.contentname;
                item.title = content.title;
            }
            else {
                item.name = content.contentname;
                if (content.contenttype == Librarian.contentType.globalFavorite)
                    item.groupid = content.contentid;
                else if (content.contenttype == Librarian.contentType.myFavorite)
                    item.presid = content.contentid;
                else if ((content.contenttype == Librarian.contentType.category) || (content.contenttype == Librarian.contentType.myFavoriteCategory))
                    item.catid = content.contentid;
            }

            return item;
        },
        getContentTypeName: function (content) {
            if ((typeof content == "undefined") || (content == null))
                return "";

            var itemType = '';
            switch (content.contenttype) {
                case Librarian.contentType.file:
                    itemType = "file";
                    break;
                case Librarian.contentType.globalFavorite:
                    itemType = "favorite_global";
                    break;
                case Librarian.contentType.myFavorite:
                    itemType = "favorite_generic";
                    break;
                case Librarian.contentType.category:
                case Librarian.contentType.myFavoriteCategory:
                    itemType = "category";
                    break;
                case Librarian.contentType.slide:
                    itemType = Librarian.Utils.getItemType(content);
                    break;
            }

            return Librarian.Lang.getString(itemType);
        },
        getContentTypeIcon: function (content) {
            if ((typeof content === "undefined") || (content === null)) {
                return '';
            }

            content = Object.toLowerKeys(content);

            var contentType = parseInt(content.contenttype, 10);
            if (isNaN(contentType)) {
                return '';
            }

            var ext = Librarian.Utils.getExtensionFromData(content, true),
                icon = '',
                category = false;
            switch (contentType) {
                case Librarian.contentType.file:
                    icon = ext;
                    break;
                case Librarian.contentType.globalFavorite:
                    icon = "favg";
                    break;
                case Librarian.contentType.myFavorite:
                    icon = "vpres";
                    break;
                case Librarian.contentType.category:
                case Librarian.contentType.myFavoriteCategory:
                    icon = "category";
                    category = true;
                    break;
                case Librarian.contentType.slide:
                    if (ext.startsWith("ppt") || ext.startsWith("pps") || ext.startsWith("pot")) {
                        icon = "ppt_slide";
                    } else if (ext == "pdf") {
                        icon = "pdf_page";
                    } else {
                        icon = ext;
                    }
                    break;
            }

            if (Librarian.extensions.isCategorizedFileTypeIcons()) {
                return Librarian.Utils.getFileTypeIcon(ext, null, category);
            }

            return Librarian.path.getFileTypeIconsPath("v1") + icon + ".gif";
        },
        getCategoryTypeFromContentType: function (contentType) {
            switch (contentType) {
                case Librarian.contentType.file:
                    return Librarian.catType.file;
                case Librarian.contentType.globalFavorite:
                    return Librarian.catType.globalFavorite;
                case Librarian.contentType.sharedFavoriteCategory:
                case Librarian.contentType.sharedFavorite:
                case Librarian.contentType.myFavorite:
                case Librarian.contentType.myFavoriteCategory:
                    return Librarian.catType.myFavorite;
                case Librarian.contentType.eventGroup:
                    return Librarian.catType.event;
                case Librarian.contentType.workItem:
                    return Librarian.catType.workflow;
            }
            return Librarian.catType.undefined;
        },
        getContentTypeFromCategoryType: function (catType, slide) {
            if (slide === true) {
                if (catType == Librarian.catType.event)
                    return Librarian.contentType.event;
                if (catType == Librarian.catType.articles)
                    return Librarian.contentType.articleSection;
                return Librarian.contentType.slide;
            }

            switch (catType) {
                case Librarian.catType.file:
                case Librarian.catType.uploads:
                case Librarian.catType.download:
                    return Librarian.contentType.file;
                case Librarian.catType.globalFavorite:
                    return Librarian.contentType.globalFavorite;
                case Librarian.catType.event:
                    return Librarian.contentType.eventGroup;
                case Librarian.catType.myFavorite:
                    return Librarian.contentType.myFavorite; // TODO: Support other favorite types, somehow
                case Librarian.catType.articles:
                    return Librarian.contentType.article;
            }
            return Librarian.contentType.undefined;
        },
        canEditFavoriteAccess: function (data) {
            if (!Librarian.features.sharedfavorite.load)
                return false;

            return Librarian.Utils.isOwner(data) && Librarian.Utils.isShared(data);
        },
        isOwner: function (data) {
            if (!data)
                return false;
            var catId = (data.catid || data.catId || -1).toInt(),
                // Check prestype to make sure this is a Favorite category
                isCat = ((typeof data.prestype == "number") && (catId >= 0)),
                presid = (data.presid || data.presId || (isCat ? catId : -1) || -1).toInt();
            if (presid < 0)
                return false;

            return (data.isowner === true) || (data.isOwner === true);
        },
        canWrite: function (data) {
            if (!data)
                return false;
            var presid = (data.presid || data.presId || -1).toInt();
            if (presid < 0)
                return false;

            return (data.isowner === true) || (data.isOwner === true) || (data.canwrite === true) || (data.canWrite === true);
        },
        isSlideShow: function (data) {
            if (!data)
                return false;
            var presid = (data.presid || data.presId || -1).toInt();
            if (presid < 0)
                return false;

            if (!data.isslideshow && !data.isSlideshow)
                return Librarian.Utils.isFavoriteType([Librarian.virtPresType.slideshow, Librarian.virtPresType.sharedSlideshow]);
            return true;
        },
        isFavorite: function (data) {
            if (!data)
                return false;
            var presid = (data.presid || data.presId || -1).toInt();
            if (presid < 0)
                return false;

            if (!data.isfavorite && !data.isFavorite)
                return Librarian.Utils.isFavoriteType([Librarian.virtPresType.myFavorite, Librarian.virtPresType.sharedFavorite]);
            return true;
        },
        isShared: function (data) {
            if (!data)
                return false;
            var presid = (data.presid || data.presId || -1).toInt();
            if (presid < 0)
                return false;

            if (!data.isshared && !data.isShared)
                return Librarian.Utils.isFavoriteType([Librarian.virtPresType.sharedFavorite, Librarian.virtPresType.sharedSlideshow]);
            return true;
        },
        isMyFavorite: function (data) {
            return Librarian.Utils.isFavoriteType(data, Librarian.virtPresType.myFavorite);
        },
        isMySlideShow: function (data) {
            return Librarian.Utils.isFavoriteType(data, Librarian.virtPresType.slideshow);
        },
        isSharedFavorite: function (data) {
            return Librarian.Utils.isFavoriteType(data, Librarian.virtPresType.sharedFavorite);
        },
        isSharedSlideShow: function (data) {
            return Librarian.Utils.isFavoriteType(data, Librarian.virtPresType.sharedSlideshow);
        },
        isFavoriteType: function (data, types) {
            if (!data)
                return false;
            var presid = (data.presid || data.presId || -1).toInt();
            if (presid < 0)
                return false;

            types = Array.from(types);
            return types.contains(data.prestype) || types.contains(data.presType);
        },
        onFailure: function(error) {
            if (!error)
                return;

            if (typeof error == "object")
                error = error.responseText || "";

            var index = error.indexOf('\n');
            if (index > 0)
                error = error.substr(0, index);

            if (error)
                Librarian.Utils.error(error, false);
        },
        getMooSelectContact: function (contact) {
            // Dynamics crm
            if (typeof contact.contactid == "string")
                delete contact.contactid;

            var text = contact.text || contact.displayname || contact.fullname || contact.name || contact.email;
            var value = contact.value;

            if (!value) {
                if (contact.contactid && contact.contacttype)
                    value = contact.contactid + '-' + contact.contacttype;
                else
                    value = contact.id || contact.email;
            }

            contact.text = text;
            contact.value = value;

            return contact;
        },
        parseCsv: function (text, delimeter) {
            var csvJson = text.match(/[^\r\n]+/g),
                objAttributeNames = csvJson[0].split("/[" + delimeter + "]+/g");

            csvJson.slice(1);

            for (var i = csvJson.length; i--;) {
                var objValues = csvJson[i].split("/[" + delimeter + "]+/g");
                for (var j = objAttributeNames.length; j--;) {
                    csvJson[i] = {};
                    csvJson[i][objAttributeNames[j]] = objValues[j];
                }
            }

            return csvJson;
        },
        isDataEqual: function (firstData, secondData) {
            if (typeof Library.isDataEquals == "function") {
                return Library.isDataEquals(firstData, secondData);
            }
            return firstData.contentid == secondData.contentid && firstData.contenttype == secondData.contenttype;
        },
        isUserMemberOfGroup: function (groupNames) {
            // Don't check anything if we don't have the groups list
            if (typeOf(Librarian.userGroups) != "array")
                return false;
            if ((typeof groupNames == "undefined") || (groupNames == null))
                return false;

            groupNames = Array.from(groupNames).invoke('toLowerCase');

            return Librarian.userGroups.filter(function (item) {
                return groupNames.contains(item.Name.toLowerCase());
            }).length > 0;
        },
        // Check if a user is a member of a group where the passed in groups are partial group names
        // Someone in the 'Everyone' group would return true for groupName = ['everyone', 'every', 'e']
        isUserMemberOfGroupLike: function (groupNames) {
            // Don't check anything if we don't have the groups list
            if (typeOf(Librarian.userGroups) != "array")
                return false;
            if ((typeof groupNames == "undefined") || (groupNames == null))
                return false;

            groupNames = Array.from(groupNames).invoke('toLowerCase');

            return Librarian.userGroups.filter(function (item) {
                return groupNames.filter(function (group) {
                    return (item.Name.toLowerCase().indexOf(group) >= 0);
                }).length > 0;
            }).length > 0;
        },
        requestStatuses: {},
        requestStatusRequest: null,
        requestStatusTimer: null,
        trackRequestStatus: function (requestId, onSuccess, onFailure) {
            if (!Librarian.Utils.requestStatuses[requestId])
                Librarian.Utils.requestStatuses[requestId] = { onSuccess: onSuccess, onFailure: onFailure };

            if (!Librarian.Utils.requestStatusTimer)
                Librarian.Utils.requestStatusTimer = setTimeout(Librarian.Utils.checkRequestStatuses, 5000);
        },
        checkRequestStatuses: function () {
            // Stop the timer, if it exists, just in case
            if (Librarian.Utils.requestStatusTimer)
                clearTimeout(Librarian.Utils.requestStatusTimer);

            // Get all of the request ids whose items are not null
            var requestIds = Object.keys(Object.filter(Librarian.Utils.requestStatuses, function (value) { return value != null; }));
            // If there are no more requests, null out the timer and stop
            if (requestIds.length == 0) {
                Librarian.Utils.requestStatusTimer = null;
                return;
            }
            // Otherwise, set up another timer loop
            else
                Librarian.Utils.requestStatusTimer = setTimeout(Librarian.Utils.checkRequestStatuses, 5000);

            // If the request hasn't finished yet, don't send another
            if (Librarian.Utils.requestStatusRequest != null)
                return;

            // Send a check request for all of the request ids in the list
            Librarian.Utils.requestStatusRequest = new Librarian.Request.JSON({
                url: Librarian.path.getMethodUrl("crst") + "&out=ujson&rid=" + encodeURIComponent(requestIds.join(',')),
                onSuccess: Librarian.Utils.onRequestCheckComplete
            });
            Librarian.Utils.requestStatusRequest.send();
        },
        onRequestCheckComplete: function (json) {
            for (var i = 0; i < json.length; i++) {
                var data = json[i],
                    request = Librarian.Utils.requestStatuses[data.RequestId];

                if (data.Failed) {
                    if (request && (typeof request.onFailure == "function"))
                        request.onFailure(data);

                    Librarian.Utils.requestStatuses[data.RequestId] = null;
                }
                else if (data.Complete) {
                    if (request && (typeof request.onSuccess == "function"))
                        request.onSuccess(data);

                    Librarian.Utils.requestStatuses[data.RequestId] = null;
                }
            }

            Librarian.Utils.requestStatusRequest = null;
        },
        openRecEngine: function (page, pageData) {
            Librarian.recWindow = new Librarian.CustomWizardWindow({
                xmlURL: Librarian.path.getLibraryPath() + "wizard/wizard.xml",
                navMenuStyle: "rec-eng-menu",
                navMenuTitleStyle: "menu-subhead",
                page: page,
                pageData: pageData
            });
            Librarian.recWindow.show();
        },
        keysToLowerCase: function(obj) {
            var keys = Object.keys(obj);
            var n = keys.length;
            while (n--) {
                var key = keys[n]; // "cache" it, for less lookups to the array
                if (key !== key.toLowerCase()) { // might already be in its lower case version
                    obj[key.toLowerCase()] = obj[key]; // swap the value to a new lower case key
                    delete obj[key]; // delete the old key
                }
            }
            return (obj);
        },
        log: function (text) {
            if (window.console)
                console.log(text);
        },
        logInfo: function (info, text) {
            if (window.console)
                console.info(info, text);
        },
        logPreviewActivity: function (data, id, params) {
            var contentId = -1, contentType = Librarian.contentType.undefined, parentId = -1, parentType = Librarian.contentType.undefined;
            if (data.slideid > 0) {
                contentId = data.slideid;
                contentType = Librarian.contentType.slide;

                if (data.presid > 0) {
                    parentId = data.presid;
                    parentType = Librarian.contentType.myFavorite;
                }
                else if (data.groupid > 0) {
                    parentId = data.groupid;
                    parentType = Librarian.contentType.globalFavorite;
                }
                else if (data.fileid > 0) {
                    parentId = data.fileid;
                    parentType = Librarian.contentType.file;
                }
            }
            else if (data.presid > 0) {
                contentId = data.presid;
                contentType = Librarian.contentType.myFavorite;
            }
            else if (data.groupid > 0) {
                contentId = data.groupid;
                contentType = Librarian.contentType.globalFavorite;
            }
            else if (data.fileid > 0) {
                contentId = data.fileid;
                contentType = Librarian.contentType.file;
            }
            else if ((data.contentid > 0) || (data.contentId > 0)) {
                contentId = data.contentid || data.contentId;
                contentType = data.contenttype || data.contentType;
            }

            if ((contentId == -1) || (contentType == Librarian.contentType.undefined))
                return;

            var url = Librarian.path.getLogUrl("logprv") + "&cntid=" + contentId + "&cnttype=" + contentType + "&parid=" + parentId + "&partype=" + parentType + "&id=" + id;

            if (params)
                url += "&" + Object.toQueryString(params);

            new Librarian.Request({
                url: url
            }).send();
        },
        logActivityDuration: function (id, sync) {
            // Send this request to the server to note that we are done looking at this slide
            new Librarian.Request({
                url: Librarian.path.getLogUrl("logactd") + "&id=" + id,
                async: sync !== true
            }).send();
        },
        getContactFeaturePermissions: function (contact) {
            Librarian.Utils.getFeaturePermissions(
                function (json) {
                    contact.features = json;
                },
                "getftrpermact",
                "&coid=" + contact.contactid + "&cotype=" + contact.contacttype
            );
        },
        getUserFeaturePermissions: function () {
            Librarian.Utils.getFeaturePermissions(
                function (json) {
                    Librarian.userInfo.features = json;
                },
                "getftrpermu"
            );
        },
        getFeaturePermissions: function (onSuccess, method, options) {
            if ((typeof onSuccess != "function") || !method)
                return;

            new Librarian.Request.JSON({
                url: Librarian.path.getAdminUrl(method) + (options || '') + "&out=cjson",
                onSuccess: onSuccess
            }).send();
        },
        // Source: http://phpjs.org/functions/strip_tags:535
        stripHTML: function (text, allowedTags) {
            // Make sure the allowed arg is a string containing only tags in lowercase (<a><b><c>)
            allowedTags = (((allowedTags || '') + '').toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []).join('');
            var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi,
                commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi;
            return text.replace(commentsAndPhpTags, '').replace(tags, function ($0, $1) {
                return allowedTags.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : '';
            });
        },
        getTinyMCEStyles: function (type) {
            if (!type)
                type = "editor";

            var css = [Librarian.path.getLayoutsPath() + "tinymce/" + type + ".css"];
            if (Librarian.editor.customCSSPath.length > 0)
                css.push(Librarian.editor.customCSSPath);
            if (Librarian.features.metroui.load)
                css.push(Librarian.path.getLayoutsPath() + "tinymce/metro.css");

            return css.join(',');
        },
        getTinyMCEDefaults: function () {
            return {
                plugins: "lists advlist code link hr",
                toolbar: "bold italic underline | alignleft aligncenter alignright | fontsize | link forecolor removeformat",
                resize: false,
                menubar: false,
                statusbar: false,
                newline_behavior: "linebreak",
                convert_urls: false,
                browser_spellcheck: true,
                // Override element rules; don't pad td with nbsp
                extended_valid_elements: "td[*]",
                custom_elements: "style",
                allow_conditional_comments: true,
                formats: {
                    // Override img to use align instead of float
                    alignleft: [
                        { selector: 'img', collapsed: false, attributes: { 'align': 'left' } }
                    ],
                    alignright: [
                        { selector: 'img', collapsed: false, attributes: { 'align': 'right' } }
                    ],
                    // Use text-align instead of margin: auto
                    aligncenter: { block: 'p', styles: { 'text-align': 'center' } }
                },
                content_css: Librarian.Utils.getTinyMCEStyles(),
                toolbar_mode: 'wrap',
                visual_table_class: "none", // Hack since it won't allow us to pass an empty value
                license_key: 'gpl'
            };
        },
        getTinyMCEOptions: function (instanceOptions) {
            var defaults = Librarian.Utils.getTinyMCEDefaults(),
                libraryOptions = Librarian.editor.options;

            return Object.merge({}, defaults, libraryOptions, instanceOptions);
        },
        // Adds to the available buttons, but still has to be included in the toolbar options
        addTinyMCEButton: function (editor, button) {
            var buttons = {
                "insertgreeting": {
                    tooltip: Librarian.Lang.getString("greeting_tooltip"),
                    text: Librarian.Lang.getString("greeting_text"),
                    onAction: function () {
                        editor.selection.setCursorLocation(editor.getBody(), 0);
                        editor.insertContent('[Email Greeting],<br><br>');
                    }
                },
                "insertsignature": {
                    tooltip: Librarian.Lang.getString("signature_tooltip"),
                    text: Librarian.Lang.getString("signature_text"),
                    onAction: function() {
                        editor.insertContent('[Email Signature]');
                    }
                },
                "insertportal": {
                    tooltip: Librarian.Lang.getString("portal_link_tooltip"),
                    text: Librarian.Lang.getString("portal_link_text"),
                    onAction: function () {
                        editor.insertContent('[Portal Link]');
                    }
                },
                "insertcontentlink": {
                    tooltip: Librarian.Lang.getString("content_link_tooltip"),
                    text: Librarian.Lang.getString("content_link_text"),
                    onAction: function () {
                        editor.insertContent('[Content Link]');
                    }
                },
                "insertdownloadlink": {
                    tooltip: Librarian.Lang.getString("download_link_tooltip"),
                    text: Librarian.Lang.getString("download_link_text"),
                    onAction: function () {
                        editor.insertContent('[Download Link]');
                    }
                },
                "insertimage": {
                    tooltip: Librarian.Lang.getString("insert_image_tooltip"),
                    icon: "image",
                    onAction: function () {
                        // Fix for IE11 inserting at beginning after losing focus
                        // https://stackoverflow.com/a/22132612
                        var position = editor.selection.getBookmark();

                        var imageWin = new Librarian.ImageSelectWindow({
                            params: {
                                subtype: Librarian.supportImageSubType.event,
                                tmpl: false,
                                all: true
                            },
                            onSuccess: function (image) {
                                var url = Librarian.path.getAbsolutePath(Librarian.path.getDownloadUrl("dsf")) + "&fh=" + image.hash;

                                editor.selection.moveToBookmark(position);

                                if (Librarian.event.maxImgWidth != null) {
                                    var img = new Image();
                                    img.src = url;
                                    img.addEventListener("load", function () {
                                        var width = this.naturalWidth;
                                        if (width > Librarian.event.maxImgWidth)
                                            width = Librarian.event.maxImgWidth;

                                        editor.insertContent("<img width='" + width + "' src='" + url + "' >");
                                    });
                                }
                                else {
                                    editor.insertContent("<img src='" + url + "' >");
                                }
                            }
                        });
                    }
                },
                "insertdisclosure": {
                    tooltip: Librarian.Lang.getString("insert_disc_tooltip"),
                    text: Librarian.Lang.getString("insert_disc_text"),
                    onAction: function () {
                        // Fix for IE11 inserting at beginning after losing focus
                        // https://stackoverflow.com/a/22132612
                        var position = editor.selection.getBookmark();

                        var discWin = new Librarian.DisclosureWindow({
                            type: Librarian.disclosureType.email
                        });
                        discWin.addEvent("complete", function (disclosures) {
                            disclosures = Array.from(disclosures);

                            disclosures.forEach(function (disclosure) {
                                var placeholder = "{!disclosure:id=" + disclosure.disclosureid + "}",
                                    html = "<p>" + placeholder + "</p>";

                                editor.selection.moveToBookmark(position);
                                editor.insertContent(html);
                            });
                        });
                    }
                }
            }

            var options = buttons[button];
            if (options)
                editor.ui.registry.addButton(button, options);
        },
        getLibrarySetting: function (name, onSuccess, onFailure) {
            if (typeof onSuccess != "function")
                return;
            if (!name)
                return;
            if (typeof name == "string")
                name = [name];
            var count = name.length,
                settings = {};
            for (var i = name.length; i--;) {
                (function (name) {
                    var request = new Librarian.Request.JSON({
                        url: Librarian.path.getMethodUrl("getsettval") + "&name=" + name + "&out=ujson",
                        onSuccess: function (value) {
                            var parsedValue;
                            try {
                                parsedValue = parseInt(value);
                                if (isNaN(parsedValue)) {
                                    parsedValue = value;

                                    if (parsedValue.toLowerCase() == "true")
                                        parsedValue = true;
                                    else if (parsedValue.toLowerCase() == "false")
                                        parsedValue = false;
                                }
                            }
                            catch (e) {
                                parsedValue = value;
                            }
                            settings[name] = parsedValue;
                            if (!--count)
                                onSuccess(settings);
                        },
                        onFailure: function(error) {
                            if (!--count) {
                                if (Object.keys(settings).length != 0)
                                    onSuccess(settings);
                            }

                            Librarian.Utils.onFailure(error);
                            if (typeof onFailure == "function")
                                onFailure(name);
                        }
                    });
                    request.send();
                })(name[i]);
            }
        },
        getUserGroupInfo: function (groupName, includeMembers, onSuccess, onFailure) {
            var request = new Request.JSON({
                method: "get",
                url: Librarian.path.getMethodUrl("getugi") + "&out=cjson&members=" + (!!includeMembers ? '1' : '0') + "&name=" + encodeURIComponent(groupName),
                onSuccess: onSuccess,
                onFailure: onFailure || Librarian.Utils.onFailure
            });
            request.send();

            return request;
        },
        setupSDDMMenu: function(options, container) {
            var menuEl = new Element("li", options.menuProperties);

            var linkEl = new Element("a", options.linkProperties).injectInside(menuEl);

            if (options.linkIconClass)
                var iconEl = new Element("span", { "class": options.linkIconClass }).injectInside(linkEl);

            if (options.linkText)
                var textEl = new Element("span", { "text": options.linkText }).injectInside(linkEl);

            var dropdownEl = new Element("div", options.dropdownProperties).injectInside(menuEl);

            Librarian.Utils.populateSDDMDropdown(dropdownEl, options.dropdownItems);
            Librarian.Utils.bindSDDMMenu(linkEl, dropdownEl);

            var containerEl = $(container);
            if (containerEl)
                menuEl.injectInside(containerEl);

            return menuEl;
        },
        populateSDDMDropdown: function(dropdownEl, dropdownItems) {
            dropdownItems.forEach(function(item) {
                var itemEl = new Element("a", item.properties).injectInside(dropdownEl);

                if (typeof item.onClick == "function")
                    itemEl.addOnClick(item.onClick);
            });
        },
        bindSDDMMenus: function (items) {
            if (!items)
                return;
            for (var i = items.length; i--;) {
                var parentEl = $(items[i].parent),
                    menuEl = $(items[i].menu),
                    onClick = items[i].onClick;
                Librarian.Utils.bindSDDMMenu(parentEl, menuEl, onClick);
            }
        },
        bindSDDMMenu: function (parentEl, menuEl, onClick) {
            if (parentEl && menuEl) {
                var clickFn = Librarian.isSurface() ? mopen.partial(menuEl, parentEl) : onClick;

                parentEl.addEvents({
                    click: clickFn,
                    mouseover: mopen.partial(menuEl, parentEl),
                    mouseout: mclosetime,
                    blur: mclosetime,
                });

                menuEl.addEvents({
                    mouseover: mcancelclosetime,
                    mouseout: mclosetime,
                    blur: mclosetime,
                    click: mclose
                });
            }
        },
        getFlaggingLocation: function (location) {
            switch (location) {
                case 0:
                    return "top-left";
                case 1:
                    return "top-right";
                case 2:
                    return "bottom-right";
                case 3:
                default:
                    return "bottom-left";
            }
        },
        getFlaggingClasses: function(data) {
            var mapping = Librarian.flagging.mapping;

            if (!Librarian.flagging.enabled || !data || !mapping)
                return [];

            // Backwards compatibility with name/value settings
            if (typeOf(mapping) != "array") {
                mapping = Object.toArray(mapping, function(value, name) {
                    return {
                        metaName: name,
                        className: value,
                    }
                });
            }

            var classes = [];

            mapping.forEach(function(flag) {
                var isFlagSet = flag.customFunction || Librarian.Utils.doesFlaggingMetaMatch;
                if (isFlagSet(data, flag)) {
                    classes.push(flag.className);
                }
            });

            return classes;
        },
        doesFlaggingMetaMatch: function(data, flag) {
            if (data.contenttype == Librarian.contentType.category && !Librarian.flagging.showOnCategory)
                return false;

            var metaName = flag.metaName;
            var metaValue = (flag.metaValue || "true").toLowerCase();

            var value = Librarian.Utils.getField(data, metaName);
            if (value == null)
                return false;

            var values = value.toString().toLowerCase().split(';');

            return values.contains(metaValue);
        },
        getField: function(data, fieldName, defaultValue) {
            if (!data)
                return defaultValue;

            var fields = data.extrafields || data.attributes;
            if (!fields)
                return defaultValue;

            // Also look for field with no spaces (e.g. from V_SearchFiles)
            var fieldNameNoSpaces = fieldName.replaceAll(" ", "");

            for (var key in fields) {
                if (!fields.hasOwnProperty(key))
                    continue;

                if (key.equalsIgnoreCase(fieldName) || key.equalsIgnoreCase(fieldNameNoSpaces))
                    return fields[key];
            }

            return defaultValue;
        },
        getHashByName: function (name) {
            if (!name) {
                return null;
            }

            var data = this.getHash().parseQueryString() || {};

            return data[name];
        },
        openLibraryTreePanel: function () {
            $("sideColumn").setStyle("display", "block");
            $("sideColumn_handle_icon").setStyle("display", "block");

            if (sideColumn.isCollapsed) {
                if (sideColumn.handleIconEl) { sideColumn.handleIconEl.click(); }
                else { sideColumn.columnToggle(); }
            }
        },
        inIframe: function () {
            try {
                return window.self !== window.top;
            } catch (e) {
                return true;
            }
        },
        getFormData: function (query) {
            var vars = query.split(/[&;]/),
                object = {};

            if (!vars.length) return object;

            vars.each(function (val) {
                var kv = val.split('='),
                    value = decodeURIComponent(kv[1]).trim(),
                    keys = decodeURIComponent(kv[0]).replace(/\[\]/g, '').match(/([^\]\[]+|(\B)(?=\]))/g),
                    obj = object;

                if (!keys) return;
                keys.each(function (key, i) {
                    var current = obj[key];

                    if (i < keys.length - 1) { obj = obj[key] = current || {}; }
                    else if (typeOf(current) == 'array') current.push(value);
                    else obj[key] = current != null ? [current, value] : value;
                });
            });

            return object;
        },
        getQueryString: function (params) {
            if (!params)
                return "";

            if (typeOf(params) == "array")
                params = params.join("&");
            else if (typeOf(params) == "object")
                params = Object.toQueryString(params);

            return params.toString();
        },
        textToHtml: function(text) {
            var lines = text.split("\n");

            return lines.map(function(line) {
                return Librarian.Utils.escapeHtml(line);
            }).join("<br>");
        },
        escapeHtml: function(text) {
            return text.escapeHtml();
        },
        getDropdownFilter: function(value) {
            if (!value)
                return null;

            var variations = [];

            variations.push(value);
            variations.push("%;" + value);
            variations.push(value + ";%");
            variations.push("%;" + value + ";%");

            return variations.join(",");
        },
        hasHtml5UploadSupport: function () {
            return window.FormData !== undefined;
        },

        getUserSetting: function(name) {
            var value = null;

            try {
                value = localStorage.getItem(name);
            }
            catch (error) {
                console.error("Could not get user setting: " + name + "\n" + error);
            }

            return value;
        },

        setUserSetting: function(name, value) {
            if (value != null) {
                try {
                    localStorage.setItem(name, value);
                }
                catch (error) {
                    console.error("Could not set user setting: " + name + "\n" + error);
                }
            }
            else
                Librarian.Utils.deleteUserSetting(name);
        },

        deleteUserSetting: function(name) {
            try {
                localStorage.removeItem(name);
            }
            catch (error) {
                console.error("Could not delete user setting: " + name + "\n" + error);
            }
        },

        validatePasswordComplexity: function (password) {
            var result = [];
            var validPassword = true;

            if (Librarian.passwordComplexityRules != null) {
                Librarian.passwordComplexityRules.forEach(function (rule) {
                    var regex = new RegExp(rule.regex);
                    var success = password.match(regex) != null;
      
                    result.push({
                        label: rule.label,
                        success: success
                    });

                    if (!success) {
                        validPassword = false;
                    }
                });
            }

            return {
                validPassword: validPassword,
                result: result
            };
        },

        addPerformanceTime: function(label, endTime) {
            var startTime = window.performance.timing.navigationStart;

            if (!endTime)
                endTime = new Date();

            var seconds = (endTime - startTime) / 1000;

            Librarian.performanceTimes[label] = seconds;

            if (Librarian.logPerformanceTimes)
                console.log(label + ": " + seconds  + " s");
        }
    };
}

Function.implement({
    // Returns a function with default arguments, and event arguments
    partial: function () {
        var self = this,
            args = Array.prototype.slice.call(arguments);
        return function () {
            var allArguments = args.concat(Array.prototype.slice.call(arguments));
            return self.apply(this, allArguments);
        };
    }
});

// Add functions to Elements and Document
(function () {
    function _addEvent(fn, bindObj, eventName) {
        if (bindObj)
            this.addEvent(eventName, fn.bind(bindObj));
        else
            this.addEvent(eventName, fn);
    }

    function _removeEvent(fn, bindObj, eventName) {
        if (typeof fn == "function") {
            if (bindObj)
                this.removeEvent(eventName, fn.bind(bindObj));
            else
                this.removeEvent(eventName, fn);
        }
        else
            this.removeEvents(eventName);
    }

    Element.implement({
        addOnKeyPress: function (keys, fn, bindObj) {
            keys = Array.from(keys);
            if (bindObj)
                fn = fn.bind(bindObj);

            var wrapperFn = function(e) {
                if (keys.contains(e.key) || keys.contains(e.keyCode))
                    fn(e);
            }

            _addEvent.apply(this, [wrapperFn, bindObj, "keypress"]);
        },

        addOnDblClick: function (fn, bindObj) {
            if (!Librarian.isAppleProduct())
                _addEvent.apply(this, [fn, bindObj, "dblclick"]);
            _addEvent.apply(this, [fn, bindObj, "tap"]);
        },

        addOnClick: function (fn, bindObj) {
            if (!Librarian.isAppleProduct())
                _addEvent.apply(this, [fn, bindObj, "click"]);
            _addEvent.apply(this, [fn, bindObj, "tap"]);
        },

        removeOnClick: function (fn, bindObj) {
            if (!Librarian.isAppleProduct())
                _removeEvent.apply(this, [fn, bindObj, "click"]);
            _removeEvent.apply(this, [fn, bindObj, "tap"]);
        },

        makeUnselectable: function () {
            if (this.nodeType == 1) {
                this.unselectable = true;
                if (typeof this.setAttribute == "function")
                    this.setAttribute("unselectable", "on");
            }

            var child = $(this.firstChild);
            while (child) {
                if (typeof child.makeUnselectable == "function")
                    child.makeUnselectable();
                child = $(child.nextSibling);
            }
        },

        getRight: function () {
            return this.getLeft() + this.getWidth();
        },

        getBottom: function () {
            return this.getTop() + this.getHeight();
        }
    });

    Document.implement({
        addOnKeyPress: function (fn, bindObj) {
            var eventName = (Browser.Engine.trident || Browser.Engine.webkit || Browser.Engine.gecko) ? "keydown" : "keypress";

            _addEvent.apply(this, [fn, bindObj, eventName]);
        },

        removeOnKeyPress: function () {
            if (Browser.Engine.trident || Browser.Engine.webkit || Browser.Engine.gecko)
                this.removeEvents("keydown");
            else
                this.removeEvents("keypress");
        }
    });
})();